const Arabic = {
  messages: {
    currency: 'ر . س',
    rent: "للايجار",
    sale: "للبيع",
    investment: "للاستثمار",
    prev: 'السابق',
    next: 'التالي',
    validateMessage: "هذا الحقل مطلوب",
    area: "م",
    confirm_title: "هل تريد تأكيد حذف العقار",
    confirmButtonText: "حذف",
    cancelButtonText: "إلغاء",
    confirmMessage: "تم حذف  العقار بنجاح",
    date_Message: "يجب اخيتار التاريخ",
    time_Message: 'يجب اختيار الوقت',
    image_Title: "هل تريد تأكيد حذف الصورة؟",
    success_Message: "تم حذف الصورة بنجاح",
    ownerPhone_Message: "رقم جوال المالك غير صحيح",
    ownerIdentity_Message:  "رقم هوية المالك غير صحيح",
    identityNumber:  "رقم هوية غير صحيح",
    receiptNumber_Message:  "رقم الصك مطلوب",
    deedNumber:  "رقم الصك غير صحيح",
    agentIdentity_Message: "رقم هوية الوكيل غير صحيح",
    agencyNumber_Message: "رقم الوكالة غير صحيح",
    agentMobile_Message: "رقم جوال الوكيل غير صحيح",
    propertyAdd_Title:  "يجب ادخال الوصف المختصر بطريقة صحيحة",
    mobile_Message:  "رقم الجوال غير صحيح",
    request_submitted : "تم تقديم طلب توثيق العقد",
    WhatsApp_Message: "مع اخصائى خدمة العملاء للاطلاع علي خدماتكم العقارية ومعرفة الخيارات المتاحة للتعاون وملاءمتها لاحتياجى الحالى . شكرا لكم",
    totalPrice: "السعر الاجمالى",
    priceDiscount: "السعر بعد الخصم",
    walletPaymentConfirmation: "تأكيد الدفع بالمحفظة",
    walletBalance: "رصيد المحفظة",
    totalOrder: "إجمالى الطلب",
    remainingBalance: "الرصيد المتبقى",
    confirmButton: "تأكيد",
    balanceInsufficient: "رصيد محفظتك غير كافى حاليًا!",
    chargeWallet: " برجاء شحن المحفظة اولا",
    btnChargeWallet: "اشحن محفظتك",
    errorOccurred: "حدث خطأ",
    regionFirst: "لطفا اختر المنطقة اولا",
    cityFirst: "لطفا اختر المدينة اولا",
    continuation: "الاستمرار",
    selectRegion: "ادخل  المنطقة",
    selectCity: "ادخل  المدينه",
    selectNeighborhood: "ادخل الحي",
    shareApps: "شارك التطبيق واربح 1000 ريال",
    shareApps_price: "شارك التطبيق واربح رصيد",
    share_Amazing: "شارك رابط دعوتك مع 100 صديق واحصل على 10 ريالات عن كل مستخدم جديد يسجل عبر رابطك.",
    button_ShareNow: "شارك التطبيق الان",
    Free_owners_tenants: "طلبات صيانة المرافق العامة",
    dedicated_Maintenance: "لاتتطلب دفع مقدماً وتسوى لاحقاً",
    requestMaintenance: "طلب صيانة جديدة ",
    Within_24hours: "خلال 24 ساعة بيدأ السعر بـ ",
    requestExpress_maintenance: "طلب صيانة سريعة",
    Within_120Minutes: "خلال 120 دقيقة بيدأ السعر بـ ",
    contactLawyer: "تواصل مع محاميك",
    lawyerNow: "تواصل مع محاميك بمبلغ",
    needFinancing: "هل تحتاج إلى تمويل يسهّل عليك",
    manageObligations: "التزاماتك ويمنحك راحة أكبر في إدارة شؤونك؟",
    ApplyFnancing: "اطلب تمويلك الآن",
    areaSymbol: "م2",
    invoiceDetails: "عرض الفاتورة",
    incorrectMobile: "رقم الجوال غير صحيح",
    brokersMobile: "رقم جوال الوسيط غير صحيح",
    Ahmed_AlMuhaisni: "أحمد المحيسني العقارية",
    payRent: "ادفع إيجارك",
    // requestMaintenance: "اطلب صيانة",
    customers: "العملاء",
    contactService: "تواصل مع خدمة",
    SpeakcustomerService: "التحدث مع خدمة العملاء",
    cancelMaintenance: "إلغاء طلب الصيانة",
    close: "أغلاق الشات",
    searchingTechnician: "جاري البحث عن فني في منطقتك!",
    TrackRequest: "تابع الطلب",
    closing: "أغلاق",
    send: "إرسال",
    unknown: "غير معروف",
    maintenanceMosques: "صيانة بيوت الله مجانا 🕌",
    godsMosques: "برفع طلب صيانة،تُسهم في عمارة بيوت الله",
    trackOrders: "تابع الطلبات",
    propertyFeatures: "مميزات العقار",
    viewAll: "عرض الكل",
    commercial: "تجاري",
    residential: "سكني",
    from: "من",
    to: "الي",
    Invite_Friends: "إدع أصدقائك واكسب حتي ",
    invite_P: "ريال في محفتك",
    invite_NewFriend: "ستحصل علي جائزة كل مرة تدعو صديق جديد لبدء رحتله مع",
    Real_EstateInvestment: "الاستثمار العقاري",
    shareInvitationLink: "شارك رابط الدعوة الخاص بك",
    hopeLocation: "نأمل مطابقة الموقع أدناه مع الموقع المذكور في وصف موقع العقار المكتوب ",
    ReliableInformation: "معلومات موثوقة من الهيئة العامة للعقار",
    adLicenseNumber: "رقم ترخيص الاعلان",
    creationDate: "تاريخ اصدار الترخيص",
    furnished: "مؤثث",
    inviteFriends_register: "ادعُ أصدقاءك للتسجيل عبر رابطك، واحصل على",
    riyals_Yourwallet: "ريالات في محفظتك عن كل مستخدم جديد يُسجّل عبر دعوتك.",
    serviceUnavailable: "الخدمة حالياً غير مدعومة في منطقتك!",
    workingExpanding: "نعمل على التوسّع قريباً, وسيتم اشعارك فور توفر الخدمه .",
    availableProperties: "استعرض العقارات المتاحة",
    discountCoupon: "هل لديك قسيمة خصم؟",
    getDiscount: "احصل على خصم عند استخدامك الرمز: FirstAM عند إتمام عملية الشراء. لا تفوت الفرصة لتوفير المزيد على مشترياتك!",
    couponCode: "ادخل رمز القسيمة",
    application: "تطبيق",
    price_beforeDiscount: "السعر قبل الخصم",
    priceAfterDiscount: "السعر بعد الخصم",
    DiscussLegal: "ناقش جميع الجوانب القانونية لعقارك.",
    participateWin: "شارك واربح",
    reliableMaintenance: "حلول صيانة موثوقة بأعلي معايير الجودة",
    realEstateBulletin: "نشرة العقارية",
    latestRealEstate_Updates: "احدث نشرات واخبار العقارية",
    exampleServiceDescription: "مثال على وصف الخدمة لشراء قطعة أرض لبناء منزلك، يتطلب ذلك توثيق عملية البيع والشراء في مكاتب التوثيق أو خدمات",
    notaryPublic: " كاتب العدل لتسجيل العقار باسمك.",
    publishedIn: "تم النشر في",
    viewFile: "عرض الملف",
    download: "تحميل",
    realEstateBulletin_Details: "تفاصيل نشرة العقارات",
    investmentProperty: "العائد الاستثماري للعقار",
    oldestNewest: "من الاقدم إلي الاحدث ",
    newestOldest: "من الاحدث إلي الاقدم",
    sendPrice: "ارسل سومتك",
    technicianChange_received: "تم استلام طلب تغيير الفني",
    sendingAnother_suitable: "ونعمل الآن على إرسال فني آخر مناسب لك في أقرب",
    soonPossible: "وقت ممكن. شكرًا لصبرك 🙏",
    thanks: 'شكرا',
    homepage: "العودة إلى الصفحة الرئيسية",
    dataAvailable: "لا توجد بيانات ",
    successfullyPaid: "تم دفع القسط المستحق بنجاح",
    sendReply: "إرسال رد",
    detailsLegalinquiry: "اكتب تفاصيل استفسارك القانوي هنا ....",
    receivedReply: "استلمنا الرد بنجاح",
    viewDocuments: "عرض المستند",
    subscriptionPackages: 'باقات الاشتراك',
    subscriptionPackage_Details: "تفاصيل باقات الاشتراك",
    target: "المستهدف",
    homeowners: "أصحاب المنازل",
    apartmentOwners: "ملاك الشقق والفلل",
    featuresIncluded: "المميزات المشمولة",
    termsConditions: "الشروط والأحكام الخاصة بالباقة",
    packageDetails: "عرض تفاصيل الباقة",
    package_Controlpanel: "لوحة تحكم الباقة",
    valuedPartner: "مرحباً بك، شريكنا المميز",
    recentActivity: "النشاط الأخير",
    manageCurrent_plan: "إدارة باقتك الحالية",
    featuresCurrent: "لقد استهلكت جزءاً كبيراً من مميزات الباقة الحالية. قم بترقية الباقة الآن للحصول على مساحات أكبر وإعلانات إضافية لتنمية أعمالك بشكل أسرع.",
    consumptionRate: "نسبة استهلاك العقارات",
    userConsumption: "نسبة استهلاك المستخدمين",
    packageRenewal: "تجديد الباقة",
    renewal: "تجديد:",
    Inactive: "غير نشطة",
    maintenance_Followup: "متابعة الصيانة",
    maintenanceSystem: "نظام الصيانة",
    subscribeNow: "اشترك الآن",
    smartControlPanel: "لوحة التحكم الذكية",
    homeMaintenance: "باقة صيانة المنازل",
    annually: "/ سنوياً",
    discountPercentage: "نسبة الخصم",
    visitsCount: "عدد الزيارات",
    usedVisits: "الزيارات المستخدمة",
    ordersReceived: "الطلبات الأخيرة المستلمة",
    viewAllRequests: "عرض كافة الطلبات",
    maintenanceDetailslocation: "تفاصيل الصيانة والموقع",
    orderNumber: "رقم الطلب",
    orderStatus: "حالة الطلب",
    orderDate: "تاريخ الطلب",
    procedure: "الإجراء",
    messageTex: "تم الاشتراك  بنجاح",
    nothing: "لايوجد",
    myAccount: "حسابي",
    myPersonal: "بيانات حسابي الشخصي",
    accountDetails: "بيانات الحساب",
    currentAccount: "نوع الحساب الحالي",
    personalAccount: "حساب شخصي",
    change_AccountType: "تعديل نوع الحساب",
    controlPanel: "لوحة التحكم",
    previews: "المعاينات",
    realEstate_Comparison: "مقارنة العقارات",
    myAccount: "حسابي",
    billboardOpposite: "هل ترغب في تعليق لوحة إعلانية ",
    chooseBoard_size: "اختر مقاس بانر",
    maintenancePackages: "باقات الصيانات",
    propertyPackages: "باقات العقارات",
    realEstate_FinancingRequest: "طلب تمويل عقاري",
    requestProperty: "اطلب عقار",
    myrentals: "ايجاراتي",
    applicant: "مقدم الطلب",
    transferProject: "مشروع التقبيل",
    propertiesNear_you: "العقارات القريبة منك",
    passwordRecovery: "استعادة كلمة المرور",
    rentedOut: "تم التأجير",
    Sold: "تم البيع",
    PropertyAge: "عمر العقار",
    addingNotes: "أضافة الملاحظات",
    editAccount_Details: "تعديل بيانات الحساب",
    mobileNumber_required: "رقم الجوال مطلوب",
    mobileNumber_displayed: "رقم الجوال المراد وضعه على اللوحه",
    customer_ServiceMessage: "السلام عليكم ورحمة الله وبركاته،اطلعت على إعلانكم عبر تطبيق عقار المحيسني، وأرغب في التواصل مع أخصائي خدمة العملاء للتعرّف على خدماتكم العقارية والخيارات المتاحة، وبحث مدى ملاءمتها لاحتياجي الحالي.شكرًا لكم، وبانتظار تواصلكم.",
    invitationCode: "هل لديك كود دعوة من صديق؟",
    enter_InvitationCode: "أدخل كود الدعوة",
    privacy_Policy: "بإنشائك الحساب فأنت توافق على شروط وسياسة الخصوصية",
    selectBannersize: "برجاء اختيار مقاس البانر للوحه اولا",
    perfectHome: "ابحث عن المنزل المثالي",
    easily: "بسهولة",
    realEstate_Offerings: "استكشف أحدث العروض العقارية في المملكة، واطلع على الشقق والفلل والاراضي، وتابع أحدث التحديثات من مصادر موثوقة في مكان واحد.",
    realEstate_platform: "منصة عقارية موحدة",
    certifiedAgents: "وكلاء معتمدون",
    dailyUpdates: "تحديث يومي",
    overProperties: "أكثر من ١٢٠ ألف عقار",
    changingStatus: "تغير حالة عقارك",
    select_PropertyStatus: "اختر حالة عقارك",
    btn_Sold: "مباع",
    btn_Rented: "مؤجر",
    btn_underReview: "تحت المراجعة",
    propertyStatuschanged: "تم تغير حالة العقار ",
    returnMyads: "العودة الي إعلاناتي",
    paylater: "استأجر الآن وادفع لاحقاً ابتداءً",
    rialsMonth: "ريال شهرياً",
    rentNow: "استأجر الآن",
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      map: 'الخريطة',
      Addadvertisement: ' إضافة إعلان',
      properties: 'إدارة الأملاك',
      login: 'تسجيل الدخول/ التسجيل',
      myads: 'إعلاناتي',
      wallet: 'المحفظة',
      myRequests: 'طلباتى',
      myProperty: 'طلبات الشراء',
      account: 'الحساب',
      accountDetails: 'تفاصيل حسابي',
      reservations: 'حجوزاتي',
      myRents: 'إيجاراتي',
      Previews: 'المعاينات',
      requestProperty: 'اطلب عقار',
      favoriteProperties: 'العقارات المفضلة',
      Maintenance: 'الصيانات',
      Payments: 'المدفوعات',
      financialTransactions: 'المعاملات المالية',
      bankAccount: 'حسابي البنكي',
      More: 'المزيد',
      Blog: 'المدونة',
      Settings: 'الإعدادات',
      frequentlyQuestions: 'اسئلة شائعة',
      Support: 'الدعم',
      SignOut: 'تسجيل الخروج',
      taxCertificate: 'الشهادة الضريبية',
      val_License: 'رخصة فال',
      sharing: 'مشاركة التطبيق',
      notifications: 'إشعارات',
      no_Notifications: 'لايوجد إشعارات',
      logOut: "تسجيل الخروج",
      oneStep: "على بعد خطوة من إنهاء رحلتك… هل ",
      twoStep: "تريد حقًا التوقف الآن؟",
      someTimes: "أحيانًا، الفرق بين التراجع والنجاح هو قرار واحد فقط.",
      buttonContinue: "استمر في التصفح",
      buttonExit: "تأكيد الخروج",
      guest: "زائر",
      mySubscription: "اشتراكي",
      supportChat: 'تواصل مع خدمة العملاء',
      chatTitle: 'التواصل بخصوص ؟',
      chatSend: 'ارسل',
      chantTitleRequired: 'يجب كتابة نبذة عن موضوع التواصل',
      chats: 'الرسائل',
      customerService: 'خدمة العملاء',
      chatCantSend: 'غير قادر على الإرسال حاليا، حاول في وقت لاحق',
      chatWithClient: 'مراسلة البائع',
      relgoin: 'غير قادر على الإرسال يرجى تسجيل الخروج وإعادة تسجيل الدخول',
      welcome: 'مرحباً',
      inviteFriends: "إدع أصدقائك",
      realEstateServices: "مركز الخدمات العقارية",
      realEstatePublications: "لا يوجد نشرات عقارية فى الفترة الحالية",
      welcomeBack: "مرحبًا ",
      goto_Profile: "انتقل لصفحتك الشخصية",
    },

    home:{
      h1: "نخبة من الفرص العقارية الفاخرة.",
      h2: "بيوت واستثمارات مختارة بعناية، تجمع بين الراحة والفخامة وتمنحك التفاصيل التي تناسب أسلوب حياتك وتطلعاتك.",
      ft_1: "المناطق",
      ft_2: "المدينة",
      ft_3: "الحي",
      ft_4: "نوع العقار",
      ft_5: "اختر اسم المنطقة",
      ft_6: "اختر المدينة",
      ft_7: "اختر الحي",
      ft_8: "اختر نوع العقار",
      fb: "ابحث",
      banner_h1: "هل لديك عقار للبيع او الإيجار؟",
      banner_h2: "إستكشف خدمة إدارة الأملاك واحصل علي المميزات بإنضمامك معنا",
      banner_b: "اضف عقارك",
      title_1: "أكتشف عقارات المملكة",
      title_2: "عرض الكل",
      title_3: "عقارات بالقرب منك",
      title_4: "عقارات مميزة",
      title_5: "عقارات مناسبة للعائلات",
      title_6: "عقارات للشباب",
      title_7: "هل تبحث عن عقار بمواصفات خاصة تناسب احتياجاتك؟",
      title_8: "قدم طلب وسنتواصل معك قريبا",
      title_9: "قدم طلب الآن",
      title_10: "أملاكك… تحت سيطرتك",
      title_11: "زد عائد أملاكك ونمِّ أصولك العقارية، ودع إدارتها علينا عبر منصتنا المتكاملة",
      title_12: "ابدأ الآن",
      title: "حمل التطبيق وانضم لنا الآن",
      Business_Transfer: "مشروعات للتقبيل",
      maintenanceRequests: "يوجد طلبات صيانة",
    },

    about: {
      title: "نظرة عامة",
      companyName: "شركة أحمد سليمان بن حمد المحيسني العقارية",
      text_1: "مجموعة سعودية رائدة في الخدمات العقارية تعمل “شركة أحمد سليمان بن حمد المحيسني العقارية” على مواكبة الرؤية الطموحة للمملكة 2030، والتي تؤسس لانطلاقة استثمارية واقتصادية جارية، حيث نقدم مفهوماً مختلفاً يعتمد على أُسس علمية ورؤية متكاملة للمستقبل عند تقديم مختلف الخدمات المتعلقة بالنشاط العقاري، سواء في خدمات الاستثمار العقاري أو التسويق العقاري للمجمعات التجارية والسكنية والإدارية، وكذلك في عمليات إدارة الأملاك والتشغيل.",
      text_2: "حاصلة على كافة الاعتمادات والتراخيص اللازمة لمزاولة الأنشطة العقارية",
      vision: "الرؤية",
      vision_p:  "أن تكون شركة أحمد المحيسني العقارية من الشركات الرائدة ميدانياً ورقمياً في المملكة، في إدارة وتشغيل وتسويق الأصول العقارية من خلال حلول متكاملة تعزز الكفاءة وترفع قيمة الاستثمارات.",
      message:  "الرسالة",
      message_p: "أن تقدم شركة أحمد المحيسني العقارية خدمات وحلولاً عقارية متكاملة مدعومة بالتقنية والحوكمة، تسهم في إدارة وتشغيل وتسويق الأصول العقارية بكفاءة وموثوقية، وتعزز القيمة المستدامة للعملاء والمستثمرين",
      fieldsWork:  "مجالات العمل",
      propertyManagement: "ادارة الأملاك",
      real_Estatemarketing: "التسويق العقاري",
      ownersUnion: "اتحاد الملاك",
      electronicMarketing: "التسويق الالكتروني",
      realEstate_Auctions: "المزادات العقارية",
      realEstate_evaluation: "التقييم العقاري",
      Off_PlanSales: "البيع على الخارطة",
      realEstate_Financing: "التمويل العقاري",
      legalServices: "خدمات قانونية",
      maintenance: "الصيانات",
      title_4: "إدارة الأملاك",
      text_13: "يقوم قسم إدارة الأملاك بالنيابة عن المالك في جميع الأعمال المتعلقة بالعقار وذلك بأعلى المعايير التي تضمن أفضل نسبة لعائد الإيجار والمتابعة الدورية ووالشؤون القانونية واعمال المحاماة وذلك من خلال إشراف فريق إدارة الأملاك .",
      title_5:  "تشمل خدمة إدارة الاملاك:",
      text_14: "الصيانة وتشمل :",
      text_15: "السباكة والكهرباء",
      text_16: "الحراسة",
      text_17: "صيانة المصاعد",
      text_18: "أعمال النظافة",
      text_19: "تعيين مشرف للعقار لمتابعة المستأجرين واستقبال بلاغات الصيانة .",
      text_20: "مراجعة الجهات الحكومية",
      text_21: "البلدية - شركة الكهرباء – المياه",
      text_22: "التسويق والتأجير",
      text_23: "حسابات مواقع التواصل الاجتماعي - حملات ممولة - لوحات إعلانية ",
      text_24: "إدارة ملف الضريبة الخاص بمالك العقار . ",
      text_25: "إدارة وتوثيق العقود في منصة إيجار .",
      text_26: "الحسابات:",
      text_27: "تحصيل دفعات الإيجار في المواعيد المحددة من خلال قسم الحسابات",
      text_28: "التحديث الدوري لأسعار الإيجارات حسب أسعار السوق.",
      text_29: "سرية المعلومات والحفاظ على الخصوصية.",
      text_30: "التقارير الإلكترونية من خلال الموقع الإلكتروني.",
      text_31: "لجنة قانونية للمرافعات بالمحكمة خاص بالمستأجرين المتعثرين بالسداد مدفوعة الأتعاب من قبل شركة أحمد سليمان بن حمد المحيسني العقارية .",
      text_32: "التسويق العقاري (خبرة ومهارة) :",
      text_33: "سرعة في البيع ووضع حلول ومزايا لترغيب العميل، تتميز مجموعة احمد المحيسني العقارية باتباع آليات تسويق ومنها :",
      text_34: "التعرف على خصائص العقار وتحديد الميزات التنافسية",
      text_35: "تصوير احترافي للعقار",
      text_36: "اعداد وكتابة المحتوى",
      text_37: "وضع خطة تسويقية",
      text_38: "نشر ومتابعة الإعلانات",
      text_39: "التقييم والتثمين العقاري :",
      text_40: "تمم تقدم لكم خدمة التقييم وفق معايير التقييم المعتمدة، حيث يتم تحديد القيمة حسب مواصفات العقار، بالإضافة إلى العوامل والمتغيرات الأساسية للسوق. يساهم ذلك في المساعدة للحصول على أفضل النتائج .",
      text_41: "جمع وتحليل البيانات",
      text_42: "تحديد القيمة السوقية",
      text_43: "أساليب تقييم متنوعة",
      text_44: "دراسة العقارات المحيطة",
      text_45: "الرؤية المستقبلية وتوقعات السوق",
      text_46: "ادارة اتحاد ملاك",
      text_47: "مجموعة احمد المحيسني العقارية لديها مختصين بإدارة اتحاد الملاك وتقديم كل الخدمات والمهام المتعلقه به مع توفير وسائل الراحه والأمان وذلك بأعلى المعايير التي تضمن استدامة العقار",
      text_48: "مميزات المجموعة",
      text_49: "فريق عمل متميز ومؤهل وذو خبرة وكفاءة عالية",
      text_50: "الربط مع الجهات الحكومية والرسمية حسب متطلباتهم",
      text_51: "توظيف التكنولوجيا والتقنيات الحديثة",
      text_52: "حاصلة على التراخيص اللازمة لممارسة الأنشطة العقارية",
      text_53: "استخدام أفضل الأنظمة في إدارة الأملاك والصيانة",
      text_54: "مركز اتصال للرد على اتصالات العملاء",
      text_55: "للتواصل والاستفسار:",
      comprehensive: "نقدم خدمات عقارية متكاملة مع تركيز",
      comprehensive_P: "على السرعة والجودة والشفافية",
      propertyManagement: "ادارة الأملاك",
      realEstate_marketing: "التسويق العقاري",
      ownersAssociation: "اتحاد الملاك",
      digitalMarketing: "التسويق الالكتروني",
      realEstate_Auctions: "المزادات العقارية",
      realEstate_Appraisal: "التقييم العقاري",
      off_plan_sales: "البيع على الخارطة",
      realEstate_financing: "التمويل العقاري",
      legalServices: "خدمات قانونية",
      maintenance: "الصيانات",
      featuresGroup: "مميزات المجموعة",
      distinguishedTeam: "فريق عمل متميز وذو خبرة وكفاءة عالية",
      qualifiedRealEstate: "نخبه من الكفاءات والكوادر العقارية المؤهله لتوجيهك نحو الخيارات الاستثمارية الافضل وتوفير استشارات موثوقة.",
      integrationGovernment: "الربط مع الجهات الحكومية والرسمية حسب متطلباتهم",
      directTechnical: "تكامل تقني مباشر مع المنصات والجهات الرسمية بالمملكة لتسريع وتسهيل كافة الإجراءات والتوثيقات الرسمية.",
      modernTechnology: "توظيف التكنولوجيا والتقنيات الحديثة",
      innovativeTechnologies: "نطوع أحدث التقنيات العقارية المبتكرة والذكاء الاصطناعي لتوفير حلول بحث ذكية وتحليلات دقيقة لحالة السوق.",
      necessaryLicenses: "حاصلة على التراخيص اللازمة لممارسة الأنشطة العقارية",
      licensedRegistered: "منشأة رسمية معتمدة بالكامل وحاصلة على كافة التراخيص من الهيئة العامة للعقار لممارسة أعمالنا بأمان وثقة تامة.",
      bestSystems: "استخدام أفضل الأنظمة في إدارة الأملاك والصيانة",
      advancedCloud_based: "نعتمد على أنظمة سحابية متقدمة لإدارة العقارات والمتابعة الفورية لطلبات الصيانة لضمان الحفاظ على قيمة أصولك.",
      customer_Callcenter: "مركز اتصال للرد على اتصالات العملاء",
      comprehensiveSupport: "مركز دعم متكامل يعمل على مدار الساعة للإجابة على استفساراتكم وتقديم الدعم الفني السريع بأسلوب مهني متميز.",
      interested: "هل انت مهتم؟",
      manageProperty: "هل لديك استفسار أو ترغب في إدارة عقارك؟",
      contactSpecialized: "يسعدنا تواصلكم مع فريق خدمة العملاء المختص بظرف لحظات للحصول على أفضل استشارة عقارية.",
      dedicatedCustomer: "يسعدنا تواصلكم مع فريق خدمة العملاء المختص بظرف لحظات للحصول على أفضل استشارة عقارية.",
      phone_WhatsApp: "هاتف ، واتس اب",
      phoneNumber: "0535000304",
      email: "ايميل",
      address: "الموقع",
      location: "المملكة العربية السعودية",
      contactNow: "تواصل معنا الان",
      aboutTeam: 'اعرف اكثر عن الفريق ',
      Who_are_we: "من نحن",
      methodologyAttention: "نعمل بمنهجية محكمة واهتمام بالتفاصيل",
    },

    map: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "الخريطة",
      title: "الموقع",
      btnAll: "الكل",
      btnSale: "للبيع",
      btnRent: "للإيجار",
      accessLocation: 'يجب السماح لنا بالوصول إلى الإحداثيات حتى نستطيع عرض العقارات على الخريطة',
    },

    addAd: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "إضـافـة إعــلان",
      breadcrumb_3: "تقبيل مشروع تجاري",
      title_1: "إعلان المالك / الوكيل",
      // title_2: "نصدر لك الترخيص من خلالنا نحن",
      // title_3: "مجموعة احمد المحيسني العقارية",
      owner_Agent_P: "إعلان موثوق لعقارك يزيد ثقه المشتري.",
      title_4: "إعلان وسيط مرخص",
      // title_5: "للعقار بالمملكة العربية السعودية",
      // title_6: "يتطلب ترخيص الإعلان من الهيئة العامة",
      brokers_P: "إدارة احترافية لإعلانات الوسطاء المرخصين",
      title_7: "توثيق  عقد",
      title_8: "توثيق فوري يحفظ الحقوق بلا تعقيد.",
      title_9: "إضـافة إعـــلان",
      title_10: "رقم هوية المالك",
      title_11: "تاريخ ميلاد المالك",
      title_12: "رقم الصك",
      title_13: "رقم جوال المالك",
      agencyPhoto: "صورة الوكالة",
      receiptImage: "صورة الصك",
      title_15: "تاريخ الصك",
      title_16: "التالي",
      title_17: "مالك",
      title_18: "وكيل",
      title_19: "رقم هوية الوكيل",
      title_20: "تاريخ ميلاد الوكيل",
      title_21: "رقم الوكالة",
      title_22: "تاريخ الوكالة",
      title_23: "رقم جوال الوكيل",
      title_24: "إضافة إعلان وسيط مرخص",
      title_25: "رقم رخصة فال",
      title_26: "رقم ترخيص الاعلان",
      title_27: "أدخل رقم رخصة فال",
      title_28: "أدخل رقم الصك",
      title_29: "أدخل رقم الترخيص",
      title_30: "أدخل رقم جوال المالك",
      title_31: "أدخل رقم هوية الوكيل",
      title_32: "أدخل رقم الوكالة",
      title_33: "أدخل جوال الوكيل",
      title_34: "التالى",
      title_35: "توثيق العقار",
      title_36: "الاسم بالكامل",
      title_37: "رقم الجوال",
      title_38: "التالى",
      title_39: "أدخل الأسم بالكامل",
      title_40: "أدخل رقم الجوال",

      title_41: "إضافة بيانات العقار",
      title_42: "تصنيف العقار",
      title_43: "تجارى",
      title_44: "سكنى",
      title_45: "الغرض من الإعلان",
      title_46: "للبيع",
      title_47: "للايجار",
      title_48: "للاستثمار",
      title_49: "نوع العقار",
      title_50: "نوع الساكن",
      title_51: "عوائل",
      title_52: "عزاب",
      title_53: "وصف للعقار",
      title_54: "وصف  تفصيلي للعقار",
      title_55: "السعر",
      title_56: "صور العقار",
      title_57: "المنطقة",
      title_58: "المدينة",
      title_59: "الحى",
      title_60: "الشارع",
      title_61: "رقم العقار",
      title_62: "رقم الطابق",
      title_63: "عدد الطوابق",
      title_64: "رقم الشقة",
      title_65: "عمر العقار",
      title_66: " مساحة العقار  2 م",
      title_67: "عدد الغرف",
      title_68: "عدد الحمامات",
      title_69: "الموقع",
      title_70: "خط الطول",
      title_71: "خط العرض",
      title_72: "أضافة مميزات العقار",
      title_73: "التالي",
      title_74: "تفاصيل الاعلان",
      title_75: "مدة الاعلان",
      title_76: "الإعلان يصنف كإعلان مميز",
      title_77: "أرسال",
      title_78: "حفظ المميزات",
      title_79: 'زراعى',
      title_80: 'توثيق العقار',
      title_81: 'إعلان تقبيل مشروع تجاري',
      title_82: "تنازل نظامي بتقييل موثق ... فرص بيع أعلي.",
      title_83: "تصوير احترافي لعقار",
      title_84: "صور احترافية تبيع عقارك أسرع .",
      title_85: "اختر نوع الساكن",
      title_86: " إعلان المالك / الوكيل",
      businessTransfer_P1: "نعرف لك الزبون المناسب والجاد في اقرب وقت!",
      businessTransfer_P2: "خلّنا نسوّق لمحلك بأقوى الطرق",
      businessTransfer_P3: "نوصل محلك لأكبر وسطاء العقار ونعرضه على العملاء",
      businessTransfer_P4: "الجادين لنضمن لك أفضل صفقة بأسرع وقت.",
      businessTransfer_button: "طلب إعلان تقبيل",
      businessTransfer_h6: "1. المعلومات الاساسية",
      businessTransfer_name: "الاسم",
      name_placeholder: "أدخل الاسم",
      businessTransfer_mobile: "رقم جوال التواصل",
      mobile_placeholder: "ادخل رقم الهاتف",
      businessTransfer_email: "البريد الالكتروني (اختياري) ",
      email_placeholder: "ادخل ⁠البريد الالكتروني",
      activity_Details: "2. تفاصيل النشاط",
      business_Activity: "⁠نوع النشاط التجاري",
      chooseType_Business: "اختر  ⁠نوع النشاط التجاري",
      Project_Area: " مساحة المشروع 2 م",
      area_placeholder: "ادخل مساحة المشروع",
      description: "وصف مختصر للنشاط",
      workersCount: "عدد العمالة",
      workers_placeholder: "ادخل عدد العمالة",
      annual_Rental: "قيمة تأجير السنوي",
      annual_placeholder: "ادخل القيمة",
      Remaining: "مدة عقد الإيجار المتبقية",
      Remaining_placeholder: "اختر ⁠المدة",
      amount: "المبلغ المطلوب",
      amount_placeholder: "ادخل المبلغ المطلوب",
      transfer_Reason: "سبب التقبيل",
      reason_placeholder: "اختر السبب",
      location: "3. موقع المشروع",
      area: "المنطقة",
      A_placeholder: "ادخل المنطقة",
      city: "المدينه",
      city_placeholder: "ادخل  المدينه",
      neighborhood: "الحى",
      neighborhood_placeholder: "ادخل  الحي",
      location_Map: "الموقع علي الخريطه",
      view: "الواجهه",
      view_placeholder: "اختر الواجهه",
      assets: "4. الأصول والموجودات",
      assetsLabel: "اكتب لنا قائمة عن الأصول داخل مشروعك (معدات – أجهزة – أثاث – ديكور – رخصة تشغيل...)",
      asset_placeholder: "ادخل القائمة",
      fixed_Asset: "حالة الاصول الثابته",
      fixed_Asset_holder: "اختر حالة الاصول الثابته",
      financial_Obigations: "هل هناك أي التزامات مالية أو ديون؟",
      projects_Strengths: "5. اذكر نقاط قوة المشروع",
      projects_Weaknesses: "6. اذكر نقاط ضعف المشروع",
      Explain: "وضّح التفاصيل",
      additional_Notes: "7. ملاحظات اضافيه",
      project_Age: "عمر المشروع",
      project_Age_holder: "ادخل ⁠ ⁠عمر المشروع",
      officesCount: "عدد المكاتب",
      officesCount_holder: "ادخل ⁠عدد المكاتب",
      roomsCount: "عدد الغرف",
      roomsCount_holder: "ادخل ⁠عدد الغرف",
      hallsCount: "عدد الصالات",
      hallsCount_holder: "ادخل ⁠عدد الصالات",
      doorsCount: "عدد الابواب",
      doorsCount_holder: "ادخل عدد الابواب",
      bathroomsCount: "عدد دورات المياه",
      bathroomsCount_holder: "ادخل عدد دورات المياه",
      floorsCount: " ⁠عدد الطوابق (الادوار)",
      floorsCount_holder: "ادخل ⁠عدد الطوابق",
      parkingCount: "عدد مواقف السيارات",
      parkingCount_holder: "ادخل عدد مواقف السيارات",
      notices: "ملاحظات أخرى تحب توصله",
      notices_holder: "وضّح ملاحظاتك",
      uploadMedia: "⁠رفع الصور",
      button_Cancel: "الغاء ورجوع",
      button_submit_request: "تقديم الطلب",
      free: "انشره مجانًا وبِع بدون سعي",
      Disclaimer: "تنويه",
      service: "الخدمة مجانية في الوقت الحالي،",
      service_2: "وستصبح مدفوعة قريبًا!",
      meterPrice: "سعر المتر",
      businessNameRequired: "يجب ادخال اسم النشاط التجاري",
      businessName: "اسم النشاط التجاري",
      brokerNumber: "رقم جوال الوسيط",
      enterBrokerNumber: "ادخل رقم جوال الوسيط",
      TypeAdvertisement: "نوعية الاعلان",
      plot_Number: "رقم الارض",
      choose_Property_Age: "أختر عمر العقار",
      numberHalls: "عدد الصالات",
      furnished: "مؤثث",
      yes: "نعم",
      no: "لا",
      saudiBuildingCode: "مطابقة لكود البناء السعودى ؟",
      propertyObligation: "هل يوجد أى الترام علي العقار ؟",
      front: "الواجهه",
      chooseInterface: "أختر الواجهه",
      choose_type_Ad: "أختر نوعية الاعلان",
      FeaturedAd: "أعلان مميز انتشار اسرع بكثير",
      real: "ريال",
      regular_Ad: "أعلان عادى - مجاناً لفترة محدوده",
      regular: "أعلان عادي بسعر",
      idType: 'نوع هوية المُعلن',
      idTypeSelect: 'اختر نوع الهوية',
      idTypePersonal: 'رقم الهوية',
      idTypeCompany: 'الرقم الموحد للمنشأة',
      advertiserId: 'رقم هوية المُعلن',
      allDataRequered: 'كل البيانات مطلوبة',
      ownerOrBroker: "إعلان المالك / وسيط مرخص",
      sellingBusiness: "بيع مشروعك يبدأ بإعلان مجاني",
      advertisingLicense: "إصدار ترخيص إعلاني",
      submitRequest: "قدّم طلب ترخيص جديد لعرض الإعلانات .",
      applicationAdvertisingLicense: "طلب إصدار ترخيص إعلاني",
      landRegistry_number: "رقم الصك او رقم العقار او السجل العيني",
      deedNumber: "أدخل رقم الصك أو رقم العقار",
      owner_Agent: "رقم هوية المالك / الوكيل",
      residencyNumber: "أدخل رقم الهوية الوطنية أو الإقامة",
      dateBirth: "تاريخ ميلاد المالك / الوكيل",
      datePlaceholder: "يوم / شهر / سنة",
      Owner_Agent_MobileNumber: "رقم جوال المالك / الوكيل",
      placeholdermobileNumber: "05xxxxxxxx",
      price: "السعر",
      propertyValue: "أدخل قيمة العقار",
      typeAdvertisement: "نوع الإعلان",
      sale: "بيع",
      rent: "إيجار",
      attachCopy: "إرفاق صورة الصك",
      certifiedDocument: "اضغط هنا لارفاق صورة الصك المعتمدة",
      supported_Fileformats: "صيغة الملف المدعومة: PDF, JPG, PNG (بحد أقصى 5 ميجابايت)",
      encounteredProblem: "لديك استفسار أو واجهتك مشكلة؟",
      contactUs: "تواصل معنا",
      paymentSubmission: "الدفع وارسال الطلب",
    },

    property: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "الاملاك",
      title_1: "طلب إدارة الاملاك",
      title_2: "عندك عقار للإيجار أو للبيع؟",
      title_3: "عقارك يستحق أن يُعرض هنا!",
      title_4: "طلب إدارة أملاك",
      title_5: "مميزاتنا في ادارة الاملاك!",
      title_6: "الصيانة",
      title_7: "سباكة و كهرباء و اعمال النضافه و صيانة المصاعد",
      title_8: "التسويق و التأجير",
      title_9: "عرض في التطبيق,منصات التواصل و حملات اعلانية",
      title_10: "الحسابات",
      title_11: "تحصيل دفعات الايجار في المواعيد المحددة ",
      title_12: "تقييم دوري للعقار ",
      title_13: "تحديث دوري لاسعار الايجارات حسب اسعار السوق",
      title_14: "خدمات قانونية و ضريبية",
      title_15: "نتابع كل امور العقار القانونية و الضريبية",
      title_16: "نسبة ادارة تنافسية",
      title_17: "5% فقط من نسبة التحصيل!",
      property_title_1: "عندك عقار للإيجار أو للبيع؟",
      propertyRentSale: "عندك عقار للإيجار أو للبيع ؟",
      propertyDeserves: "عقارك يستحق أن يُعرض هنا",
      property_title_3: "تشمل خدمة إدارة الاملاك:",
      service_include_1: "الصيانة الدورية (سباكة - كهرباء - مصاعد - نظافة) مع متابعة البلاغات",
      service_include_2: "تعيين مشرف للعقار لمتابعة المستأجرين واستقبال طلبات الصيانة",
      service_include_3: "مراجعة الجهات الحكومية ذات العلاقة (البلدية - الكهرباء – المياه)",
      service_include_4: "التسويق والتأجير حسابات والحملات الممولة وللوحات الإعلانية ",
      service_include_5: "إدارة ملف الضريبة الخاص بمالك العقار",
      service_include_6: "إدارة وتوثيق العقود في منصة إيجار",
      service_include_7: "تحصيل دفعات الإيجار في المواعيد المحددة ومتابعتها عبر قسم الحسابات",
      service_include_8: "تحديث أسعار الإيجارات دوريًا وفق حركة السوق",
      service_include_9: "الحفاظ على سرية معلومات المالك والمستأجرين",
      service_include_10: "تقديم التقارير الإلكترونية عبر لوحة التحكم في الموقع",
      service_include_11: "لجنة قانونية مختصة بمتابعة قضايا المستأجرين المتعثّرين، مع إمكانية سداد مدفوعات الأتعاب من قبل مجموعة أحمد المحيسني العقارية وفق الاتفاق ",
      btn_contactCustomer: "تواصل مع خدمة العملاء",
      vacancy: "الشاغر",
      Landlord: "المؤجر",
      Sold: "المباع",
      rentalDetails: "تفاصيل الايجار",
      rentalValue: "القيمة الايجارية",
      allProperties: "كل العقارات",
      propertyDetails: "تفاصيل العقارات",
      viewDocuments: "عرض المستندات",
      amountsCollected: "المبالغ المحصلة",
      amountsDue: "المبالغ المستحقة",
      overdueAmounts: "المبالغ المتأخرة",
      contactManager: "تواصل مع مدير حسابك",
      owner_controlPanel: "لوحة تحكم المالك",

    },

    profile: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "تفاصيل حسابي",
      fullName: "أسمك بالكامل",
      email: "بريدك الالكتروني",
      Absher_mobile: "رقم جوال ابشر",
      Save_Changes: 'حفظ التغيرات',
      accountDetails: "تفاصيل حسابى",
      changePassword: "تغير كلمة المرور",
      distinguishedOwner: "مالك مميز",
      activeAds: 'اعلانات نشطة',
      underReview: 'تحت المراجعة',
      falLicenseNum: 'رقم رخصة فال',
      aqaryLine1: 'عقاري',
      aqaryLine2: 'متميز',
      priceLine1: 'ملتزم',
      priceLine2: 'بالرسوم',
      since: 'منذ',
      lastSeen: 'آخر ظهور',
      profileMenu: 'الملف الشخصي',
      about: 'عن المرخص',
      dial: 'اتصال مباشر',
      whats: 'تواصل عبر الواتس',
      currentAccount: "نوع الحساب الحالي ", 
      changeAccount_Type: "تغير نوع الحساب",
      accountType: "نوع الحساب",
      accountDetails: "بيانات الحساب ",
      accountVerification: "تأكيد الحساب",
      accountType_suitable: "يرجى اختيار نوع الحساب المناسب لنشاطك العقاري",
      RealEstate_Entity: "منشأة عقارية",
      licensed_RealEstate: "حساب للشركات والمنشآت العقارية",
      realEstate_Broker: "وسيط عقاري",
      licensed_RealEstate_brokers: "حساب للوسطاء العقاريين المرخصين ",
      personal: "شخصي",
      personalAccount: "حساب شخصي للأفراد",
      importantInformation: "معلومة مهمة",
      detailsReviewed: "سيتم مراجعة بياناتك من قِبل فريق الإدارة خلال 1-3 أيام عمل قبل تفعيل نوع الحساب الجديد للاستفادة من مميزات المنصة بالكامل.",
      back: "رجوع",
      next: 'التالي',
      realEstate_EntityDetails: "بيانات المنشأة العقارية",
      requiredFields: "يرجى تعبئة الحقول المطلوبة ورفع المستندات الرسمية المعتمدة",
      establishmentDetails: "بيانات المنشأة",
      commercialRegistration: "رقم السجل التجاري",
      enter_Commercialregistration: "أدخل رقم السجل التجاري",
      fALLicense_Number: "رقم رخصة فال (VAL)",
      enterFallicenseNumber: "أدخل رقم رخصه فال",
      expirationDate: "تاريخ الانتهاء",
      licenseExpiration_Date: "أدخل تاريخ الانتهاء الرخصة",
      uploadingRequiredDocuments: "رفع المستندات المطلوبة",
      FalLicense: "رخصة فال",
      clickUploadFile: "اضغط لرفع الملف",
      pleaseEnsure: "يرجى التأكد من وضوح المستندات وصلاحيتها قبل رفعها. يجب أن تكون الملفات بصيغة PDF أو صورة واضحة.",
      licenseIssued: "صورة رخصة فال الصادرة من الهيئة العامة للعقار",
      fileMustbe: "يجب أن يكون الملف بصيغة PDF أو صورة واضحة ومقروءة لا تتعدى 5 ميجابايت",
      submitRequest: "إرسال الطلب",
      realEstateBrokerDetails: "بيانات الوسيط العقاري",
      basicLicense_Information: " المعلومات الأساسية للرخصة",
      commercialRegistrationissued: "صورة السجل التجاري الصادر من وزارة التجارة",
      pleaseAttach: " يرجى إرفاق نسخة واضحة ومحدثة وصالحة المفعول للسجل التجاري",
      commercialRegistrat_image: "صورة السجل التجاري",
      dataSent: "تم إرسال بياناتك",
      successfullySubmitted: "تم ارسال طلبك بنجاح! سيتم مراجعة طلبك من قِبل الفريق خلال 1-3 أيام عمل، شكرا لكم.",
      myAccount: "عودة الى حسابي",
      homePage: "الذهاب الى الصحفة الرئيسية",
      establishment: "اسم المنشأة",
      aboutLicensee: "عن المرخص",
      serviceNumber: "الرقم الموحد لخدمة العملاء",
      companyLogo: "شعار الشركة",
      companyLogoAttach: "يرجى إرفاق نسخة واضحة لشعار الشركة",
      enterEstablishment: "ادخال اسم المنشأة",
      changeyour_Account: "هل ترغب في تغيير نوع حسابك ؟",
      alert: "تنبيه",
    },

    myrequests: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "طلباتى",
      Property_management: "ادراة الاملاك",
      Contract_Documentation: "توثيق عقد",
      RealEstate_Financing: "التمويل العقاري",
      RealEstate_Requests: 'طلبات العقار',
      orderNumber: "رقم الطلب",
      families: "عائلى",
      single: "عزاب",
      title_1: "انت لم تطلب اي طلب حتى الان!",
      title_2: "إذا احتجت اي طلب لا تتردد، أطلبها فورا",
      title_3: "مقدم الطلب :",
      title_4: "رقم الهاتف :",
      title_5: "المبلغ :",
      allRequests: "الكل",
      legal: "أستشارات قانونية",
      photographyRequests: "طلبات تصوير احترافى",
      transferRequests: "طلبات التقبيل",
      advertisingLicense: "ترخيص إعلاني",
      identityNumber: "رقم الهوية",
    },

    myproperty: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "طلبات الشراء",
      Collected: 'تم التحصيل',
      more: 'اعرف المزيد',
      title_1: 'لا توجد طلبات شراء مضافة بعد!',
      title_2: 'هل تريد شراء عقار ؟ ستظهر جميع طلبات الشراء المضافه هنا',
      title_3: 'شراء عقار',
    },

    myreservations: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "حجوزاتى",
      title_1: 'انت لم تحجز اى عقار',
      title_2: 'لا تخليه بخاطرك و ابدا في شراء بيت العمر!',
      button: 'تصفح عقارتنا',
      Previous: 'السابق',
      Next: 'التالى',
    },

    myrents: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "إيجاراتى",
      Maintenance_request: 'طلب صيانة',
    },

    previewlist: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "المعاينات",
      title_1: 'انت لم تحجز اي معاينة',
      title_2: 'لا تخليه بخاطرك و ابدا في شراء بيت العمر!',
      button: 'تصفح عقارتنا',
      Previous: 'السابق',
      Next: 'التالى',
    },

    advertisements: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "أعلاناتى",
      title_1: 'ادارة الاعلانات',
      title_2: 'لا توجد اعلانات مضافة بعد!',
      title_3: 'لم يتم اضافة اي اعلان اضف اعلان لعقارك الان',
      title_4: 'وتابعه من خلال الصفحة',
      button: 'اضف اعلان جديد',
      edit: 'تعديل',
      delete: 'حذف',
      endDate: 'تاريخ إنتهاء رخصة الإعلان',
      detailsLink: 'عرض التفاصيل على الهيئة العامة للعقار',
      fal: 'رقم رخصة فال',
      region: 'المنطقة',
      city: 'المدينة',
      neighborhood: 'الحي',
      propertyType: 'نوع العقار',
      planNumber: 'رقم المخطط',
      landNumber: 'رقم القطعة',
      numberOfRooms: 'عدد الغرف',
      propertyArea: 'مساحة العقار',
      streetWidth: 'عرض الشارع',
      propertyFace: 'واجهة العقار',
      propertyUsages: 'استخدام العقار',
      guaranteesAndTheirDuration: 'الضمانات ومدتها',
      propertyUtilities: 'خدمات العقار',
      locationDescriptionOnMOJDeed: 'وصف موقع العقار حسب الصك',
      obligationsOnTheProperty: 'الإلتزامات الاخرى على العقار',
    },

    propertyrequest: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "طلب عقار",
      title_1: 'المنطقة',
      title_2: 'المدن',
      title_3: 'الحي',
      title_4: 'نوع العقار',
      title_5: 'الغرض',
      title_6: 'للشراء',
      title_7: 'للايجار',
      title_8: 'السعر المطلوب',
      title_9: 'أقل سعر',
      title_10: 'أعلي سعر',
      title_11: 'نوع السكن',
      title_12: 'عزاب',
      title_13: 'عوائل',
      title_14: 'عدد الغرف',
      title_15: 'رقم الطابق',
      title_16: 'عمر العقار',
      title_17: 'أضافة مميزات العقار',
      title_18: ' طلب العقار ',
      title_19: 'تمت اضافة طلب العقار بنجاح',
      title_20: 'ستتواصل معك قريباً لعرض خيارات تسر خاطرك ',
      title_21: 'بإذن الله',
      title_22: 'تصفح عقارات أخرى',
      title_23: 'اختر المنطقة',
      title_24: 'اختر أسم المدينة',
      title_25: 'اختر أسم الحي',
      title_26: 'اختر نوع العقار',
      title_27: 'حفظ المميزات',
      title_28: 'ادخل مدة العقار بالسنة',
      newTitle: "سنتواصل معك قريبًا لطرح الخيارات الأنسب لك",
      area: "المساحة",
      details: "التفاصيل",
      explain_Details: "وضح التفاصيل",
    },

    favoriteProperties: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "العقارات المفضلة",
      title_1: "لا توجد لديك عقارات مفضلة",
      title_2: "معقول؟ تصفح عقاراتنا و متأكدين راح تنبهر",
      title_3: "تصفح عقارتنا",
    },

    maintenances: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "الصيانات",
      breadcrumb_3: "طلب صيانة جديد",
      title_1: "خلال 24 ساعة،يبدأ السعر ",
      price: " ريال",
      title_2: "طلب صيانه سريعه!",
      title_3: "خلال 120 دقيقة،يبدأ السعر",
      title_4: "صيانة بيوت الله",
      title_5: "بطلبك هذه الخدمة تساهم بالأجر في العناية بمساجد الله",
      title_6: "عنوان المشكلة",
      title_7: "نوعية المشكلة",
      title_8: "أختر نوعية المشكلة",
      title_9: "كود الخصم",
      title_10: "تطبيق",
      title_11: "وصف شامل للمشكلة",
      title_12: "ارفق صور للمشكلة",
      title_13: "الموقع",
      title_14: "خط الطول",
      title_15: "خط العرض",
      title_16: "طلب الصيانه",
      title_17: "تم طلب الصيانه بنجاح",
      title_18: "سيتم تعيين فني لمشكلتك و سيحضر في اسرع وقت لحل المشكلة بكل سهولة",
      title_19: "عودة الى الصيانات",
      title_20: "تم التفعيل بنجاح",
      title_21: "الاستمرار",
      title_22: "ريال",
      title_23: "",
      title_24: "",
      looking_provider: 'جاري البحث عن مزود الخدمة المناسب لخدمتك',
      order_number: 'رقم الطلب',
      service_name: 'الخدمة المطلوبة',
      title: 'وصف المشكلة',
      description: 'تفاصيل المشكلة',
      image: 'صورة المشكلة',
      chat: 'المحادثة',
      order_received: 'استلمنا طلب الصيانة الخاص بك',
      manaule_assign: 'سيتم اسناد مزود الخدمة من قبل خدمة العملاء والتواصل معك في اسرع وقت ممكن',
      phoneNumber: "رقم الهاتف",
      orderDetails: "تفاصيل الطلب",
      seriousnessPrice: "سعر جدية الطلب",
      amountPaid: "المبلغ المدفوع",
      orderStatus: "حالة الطلب",
      technician: "جاري البحث عن فني",
      confirmed: "تم تأكيد طلبك وجاري البحث عن افضل فني في",
      area: "منطقتك!",
      technicalInformation: "معلومات الفني",
      help: "مساعدة",
      hasOrder: "لديك طلب صيانة",
      serviceCost: "تكلفة الخدمة",
      totalAmount: "المبلغ الكلي",
      scheduleMaintenance: "هل تريد جدولة الصيانة مستقبلا ؟",
      locationRequired: "يجب تحديد الموقع على الخريطة",
    },

    maintenanceslist: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "الصيانات",
      breadcrumb_3: "سجل الصيانات",
      title_1: "اضافة طلب صيانة جديد",
      title_2: "انت لم تطلب اي صيانة حتى الان",
      title_3: "اذا احتجت اي صيانة في عقاراتك، فأطلبها فورا!",
      title_4: "صيانات جارية",
      title_5: "صيانات تمت",
      title_6: "رقم الطلب",
      maintenanceRequest: "طلب صيانه",
      serviceRating: "تقييم الخدمة",
      orderDetails : "تفاصيل الطلب",
      re_Order: "إعادة الطلب",
    },

    maintenanceDetails: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "الصيانات",
      breadcrumb_3: "تفاصيل الطلب",
      title_1: "تم حل المشكلة",
      title_2: "وصل الفني و بدأ العمل على المشكلة",
      title_3: "تم تعيين فني للمشكلة الموصوفة",
      title_4: "تم طلب صيانة جديدة",
      title_5: "الدفع",
      title_6: "الغاء طلب الصيانه",
      title_7: "ريال",
      title_8: "اسباب الغاء طلب الصيانه",
      title_9: "اختر سبب الغاء الطلب",
      technician: "الفني المسؤول",
      providerNotes: "ملاحظات المزود",
      imageBefore: "الصورة قبل الصيانة",
      imageAfter: "الصورة بعد الصيانة",
      evaluateExperience: "قيم تجربتك",
      customerRate: "تقييم العميل",
      maintenanceCost: "تكلفة الصيانه",
      onlyRiyal: "ريال فقط لاغير",
      tip: "اضافة اكرامية",
      optionalTip: "ادفع اكرامية اختيارية للفني",
      paymentSuccessful: "تم الدفع بنجاح",
      honorServe: "تشرفنا بخدمتك،وبيتك عامر فيك دائماً",
      backMaintenance: "عودة الى الصيانات",
      successfullyEvaluated: "تم تقيم تجرتبك بنجاح",
      maintenanceService: "كيف كانت خدمة الصيانة؟",
      feedback: "ملاحظاتك تهمنا",
      btnConfrim: "إرسال",
      theTechnician: "الفني في الطريق اليكم",
      request_ChangeProvider: "طلب تغيير مزود",
      ProblemTechnician: "هل لديك مشكلة مع الفني؟",
      avoidProblem: "نعتذر منك عن ما بدر منا من خطأ، شاركنا من فضلك سبب الالغاء لنتفادي هذه المشكلة المره القادمة!",
      successfullyResolved: "تم حل المشكلة بنجاح",
      laborCost: "تكلفة شغل اليد",
      serviceCost: "تكلفة الخدمة",
      spareParts: "تكلفة قطع الغيار",
      totalAmount: "المبلغ الكلي",
      serviceRequest: "طلب الخدمة :",
      doneTime: "انتهاء الخدمة :",
      orderScheduled: "طلبكم مجدول بتاريخ",
      maintenanceAppointment: "موعد الصيانة",
      demand: "الطلب",
      future: "مستقبلا",
      cancelOrder: "الغاء الطلب :",
      opinionMatters: "رايك يهمّنا، نود معرفة سبب إلغاء الطلب لتحسين تجربتك مستقبلًا 🙏",
      successfullyCancelled: "تم الغاء الطلب بنجاح",
      reasonCancellation: "شكرًا لمشاركتك سبب الالغاء، ونتطلع لخدمتك مرة أخرى مستقبلًا !",
      maintenanceRequest: "طلب صيانة جديدة",
    },

    wallet: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "المحفظة",
      title_1: 'رصيدك الحالى',
      title_2: 'اخر المعاملات',
      title_3: 'الكل',
      title_4: 'إضافة الرصيد',
      title_5: 'حجز عقارات',
      title_6: 'حجز معاينة فاخرة',
      title_7: 'طلب صيانات',
      title_8: 'لا توجد معاملات حتي الان !',
      title_9: 'استخدم محفظتك بكل سهولة في كل التعاملات',
      title_10: 'اشحن محفظتك الان',
      title_11: 'المبلغ المطلوب إضافته',
      title_12: 'طريقة الدفع',
      title_13: 'اختر طريقة الدفع',
      title_14: 'بطاقات بنكية',
      title_15: 'الدفع',
      title_16: 'محفظة الكترونية',
      message: 'يرجي ادخال المبلغ المطلوب',
      FeaturedAd: "إعلان مميز",
      rentPayment: "دفع الايجار",
      bankCard: "الدفع عبر البطاقة البنكية أو Apple Pay",
      appWallet: "عبر محفظتك داخل التطبيق",
      cost: "التكلفة",
      choosePayment_Method: "برجاء اختيار الطريقة المناسبة للدفع",
      payment: "الدفع",
    },

    financialTransactions: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'المعاملات المالية',
      title_1: 'انت لم تقم بأي معاملات مالية حتى الان',
      title_2: 'تظهر هنا كل التعاملات لتتابع كل امورك بشكل جيد',
    },

    backAccount: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'حسابي البنكي',
      title_1: "رقم حسابك",
      title_2: "اسم البنك",
      title_3: "اسم صاحب الحساب",
      title_4: "حفظ التغيرات",
    },

    blog:{
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'المدونة',
    },

    Settings:{
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'الاعدادت',
      title_1: 'تغير كلمة المرور',
    },

    questions:{
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'الاسئلة الشائعه',
    },

    citiesList:{
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'مدن المنطقة',
      search: "أبحث عن المدينة",
      notFound: "لا توجد مدن متاحة لهذه المنطقه حتي الان !",
    },

    propertielist:{
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'البحث',
      title_1: 'نتائج البحث',
      title_2: 'المنطقة',
      title_3: 'اختر المنطقة',
      title_4: 'المدن',
      title_5: 'اختر أسم المدينة',
      title_6: 'الحي',
      title_7: 'اختر أسم الحي',
      title_8: 'نوع العقار',
      title_9: 'اختر نوع العقار',
      purpose: 'الغرض',
      title_11: 'للبيع',
      title_12: 'للايجار',
      title_13: 'ميزانية سعر الإيجار',
      title_14: 'أقل سعر',
      title_15: 'أعلي سعر',
      title_16: 'نوعية الساكن',
      title_17: 'عزاب',
      title_18: 'عوائل',
      title_19: 'عدد الغرف',
      title_20: 'رقم الطابق',
      title_21: 'عمر العقار',
      title_22: 'ابحث عن نتائج',
      title_23: 'حذف البحث',
      title_24: 'لا توجد نتائج للبحث حاليا !',
      area: "المساحه ",
      price: "السعر",
      from: "من",
      to: "الي",
    },

    propertydetails: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'تفاصيل عن العقار',
      title_1: 'متاح للبيع',
      title_2: 'مميزات العقار',
      title_3: 'وصف العقار',
      title_4: 'الشارع',
      title_5: 'رقم المبني',
      title_6: 'رقم الشقة',
      title_7: 'عدد الطوابق',
      title_8: 'رقم الطابق',
      AdvertiserInformation: 'معلومات المعلن',
      title_10: 'وكيل العقار',
      title_11: 'احجز العقار لحين الشراء',
      title_12: 'حجز معاينة',
      title_13: 'التمويل العقاري',
      title_14: 'الموقع',
      title_15: 'يجب تسجل الدخول',
      title_16: 'لحجز المعاينة يجب عليك تسجيل الدخول الى',
      title_17: 'حسابك / إنشاء حساب جديد عبر نفاذ',
      title_18: 'تسجيل الدخول',
      title_19: 'إنشاء حساب جديد بواسطه',
      title_20: 'نفـاذ',
      // title_21: 'دفع رسوم حجز العقار يعني الموافقة على حق',
      // title_22: 'العدول عن العقد دون استرداد مبلغ الحجز',
      title_23: 'يُعد دفع مبلغ حجز العقار رغبةً في الشراء، ويُخصم من قيمة العقار عند إتمامه، وفي حال عدم إتمام الشراء خلال سبعة (7) أيام من تاريخ الدفع يُعد ذلك عدولًا نهائيًا ولا يُسترد مبلغ الحجز.',
      // title_24: 'عدولًا نهائيًا، ولا يُسترد مبلغ الحجز',
      title_25: 'متاح للايجار',
      title_26: 'متاح للاستثمار',
      ownerName: "مالك هذا العقار",
      reportAd: "الابلاغ عن هذا الاعلان",
      renter: "مستأجر العقار",
      renterName: "المستأجر", 
      lawyer: "محاميك",
      contact: "تواصل مع",
      customers: "العملاء",
      contactService: "تواصل مع خدمة",
      financing: "هل ترغب في التقدم بطلب للحصول على تمويل؟",
      financingHelps: "يساعدك طلب التمويل علي دفع ايجارك بكل سهولة ويسر مما يتح لك التركيز علي أمور أخرى في",
      financialObligations: "حياتك دون القلق بشأن التزاماتك المالية",
      requestFinancing: "طلب التمويل",
      propertyDocuments: "أوراق العقار",
      deedNumber: "رقم الصك",
      identityImage: "صورة الهوية",
      Viewimage: "عرض الصورة",
      buildingLicence: "رخصة البناء",
      viewLicence: "عرض الرخصة",
      civilDefense: "شهادة في الدفاع المدني",
      viewcertificate: "عرض الشهادة",
      newMaintenance: "طلب صيانة جديد",
      more: "المزيد",
      showLess: "عرض الاقل",
      licenseNumber: "رقم الترخيص الاعلاني",
      propertyAge: "عمر العقار",
      propertyType: "نوع العقار",

    },

    previewdetails: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'المعاينات',
      breadcrumb_3: 'المعاينة القادمة',
      title_1: 'العقار المطلوب للمعاينة',
      title_2: 'وكيلنا لهذا العقار',
      title_3: 'وكيل العقار',
      title_4: 'سداد سعر المعاينة',
      title_5: 'الموقع',
      title_6: 'متأكد من إلغاء المعاينة',
      title_7: 'متأكد من انك لا تريد معاينة هذا العقار؟ لابأس',
      title_8: 'يمكنك أن تجد المزيد من العقارات الرائعه لدينا',
      title_9: 'أريد معاينة هذا العقار',
      title_10: 'إلغاء المعاينة',
      title_11: 'تم إلغاء المعاينة بنجاح',
      title_12: 'تصفح المزيد من العقارات الرائعه لدينا لتجد العقار',
      title_13: 'تصفح عقارات أخرى',
      ownerName: "مالك هذا العقار",
      confirmMsg: "تم سداد حجز المعاينة بنجاح",
      btn_backHome: "عودة إلى الرئيسية",
    },

    propertymanagement: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'إدارة أملاك',
      title_1: 'إضافة طلب إدارة أملاك',
      title_2: 'الاسم بالكامل',
      title_3: 'رقم التواصل',
      title_4: 'المنطقة',
      title_5: 'المدينة',
      propertyDescription: 'وصف العقار',
      title_7: 'تقديم طلب',
      title_8: 'تم رفع البيانات بنجاح',
      // title_9: 'يشرفنا التواصل معك عبر قسم إدار الأملاك',
      // title_10: 'لنقدم لك تجربة مميزة',
      title_11: 'العودة للرئيسية',
      title_12: 'هذا الحقل مطلوب',
      paragraph: "سنتواصل معك قريبًا عبر قسم إدارة الأملاك لتقديم خدمة مميزة لك.",
      receiptNumber: "رقم الصك",
    },

    propertypreview: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'تفاصيل عن العقار',
      breadcrumb_3: 'حجز موعد معاينة للعقار',
      title_1: 'مواعيد العمل',
      title_2: 'أختر الوقت',
      title_3: 'احجز المعاينة الفاخرة الان',
      title_4: 'سياره فاخرة وسائق خاص بيجيك ويوصلك للعقار ويوصلك لبيتك بعد المعاينة مع مسوق خاص ينتظرك ',
      title_5: 'حجز معاينة سريعة',
      title_6: 'حجز معاينة فاخرة',
      title_7: 'تم حجز المعاينة بنجاح! سنكون بانتظارك',
      price:   "ب 500 ",
      only: ' فقط',
      title_8: 'تفاصيل المعاينة',
      title_9: 'رقم وكيل العقار',
      title_10: 'عودة إلى الرئيسية',
      address: "العنوان",
      paymentSuccessfully: "تم تأكيد الدفع بنجاح . نشكركم على ثقتكم",
      paymentProcess:  "عمليه الدفع قد تمت بنجاح ، وقد تم تاكيد استلام المبلغ المطلوب نشكركم على ثقتكم ونتطلع إلى خدمتكم دائماً",
      btn_backHome: "الذهاب للرئيسية",
      location: "يرجي تحديد الموقع الخاص بك",
      normal_preview: 'معاينة سريعة',
      fancy_preview: 'معاينة فاخرة',
      preview_location: 'موقع المعاينة',
    },

    propertyreservation: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'تفاصيل عن العقار',
      breadcrumb_3: 'احجز العقار  لحين الشراء',
      stepsCompleteRental: "خطوات إتمام الإيجار",
      propertyReservation: ' حجز العقار',
      confirmsyour_Serious: "يضمن جدية النية ويكون علامة لنا لبدء تجهيز العقود، كما تخصم قيمة الحجز من قيمة الإيجار.",
      contractsSent: "نرسل لك العقود على منصة إيجار",
      afterReservation: "بعد الحجز، نبدأ في تجهيز العقود وإرسالها لمنصة إيجار، سنرسل لك إشعار بجاهزية العقود.",
      payRent: "ادفع الإيجار واسكن فوراً",
      verifyContracts: "تأكد من صحة العقود على منصة إيجار وتم البيع في تطبيقنا و اسكن فوراً",

      title_12: 'حجز العقار بـ',
      title_13: 'ريال',
      title_14: 'هل اقدر استرد قيمة الحجز ؟',
      title_15: "دفع رسوم حجز العقار يعني الموافقة على حق العدول عن العقد دون استرداد مبلغ الحجز",
      title_16: 'إذا لم يتم التنفيذ خلال 3 أيام من الدفع، يُعتبر ذلك عدولًا نهائيًا، ولا يُسترد مبلغ الحجز',
      successfullyBooked: "تم حجز العقار بنجاح!",
      contractswithin: "سنعمل علي تجهيز العقود في خلال ال48 ساعه",
      realEstate_Exchange: "القادمة عبر البورصه العقارية",
      notificationSoon: "وسنرسل لك اشعار بمجرد الانتهاء",
      btn_backHome: "عودة إلى الرئيسية",
      verifyValidity: "تأكد من صحة العقود على تطبيق البورصة العقارية و تمم البيعة في التطبيق ",
      ownershipOfficially: "ويتم نقل الملكية رسميا باسمك",
    },

    blogDetails: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'المدونة',
      breadcrumb_3: 'تفاصيل المدونة',
    },

    changePassword: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'الاعدادت',
      title_1: 'تغير كلمة المرور',
      title_2: 'كلمة المرور القديمة',
      title_3: 'كلمة المرور الجديدة',
      title_4: 'إرسال',
      confirmMessage: "تم تغير كلمة المرور بنجاح",
    },

    forgetPassword: {
      title_1: 'نسيت كلمة المرور',
      title_2: 'رقم جوالك',
      title_3: 'أدخل رقم جوالك',
      title_4: 'ادخل الكود المرسل',
      title_5: 'كلمة المرور الجديدة',
    },

    propertieupdate: {
      breadcrumb_1: '',
      breadcrumb_2: '',
      breadcrumb_3: '',
      title_1: 'نوع المالك',
      title_2: 'مالك',
      title_3: 'وكيل',
      title_4: 'وسيط عقاري',
      title_5: 'إضـافة إعـــلان',
      title_6: 'صور الصك',
      title_7: 'رقم الصك',
      title_8: 'تاريخ الصك',
      title_9: 'رقم هوية المالك',
      title_10: 'تاريخ ميلاد المالك',
      title_11: 'رقم جوال المالك',
      title_12: 'رقم هوية الوكيل',
      title_13: 'رقم الوكالة',
      title_14: 'تاريخ الوكالة ',
      title_15: 'تاريخ ميلاد الوكيل ',
      title_16: 'رقم جوال الوكيل',
      title_17: 'إضافة إعلان وسيط مرخص',
      title_18: 'رقم رخصة فال',
      title_19: 'رقم ترخيص الاعلان',

      title_20: 'توثيق العقار',
      title_21: "الاسم بالكامل",
      title_22: "رقم الجوال",
      title_23: "أدخل الأسم بالكامل",
      title_24: "أدخل رقم الجوال",

      title_25: "إضافة بيانات العقار",
      title_26: "تصنيف العقار",
      title_27: "تجاري",
      title_28: "سكني",
      title_29: "الغرض من الإعلان",
      title_30: "للبيع",
      title_31: "للايجار",
      title_32: "للاستثمار",
      title_33: "نوع العقار",
      title_34: "نوع الساكن",
      title_35: "عوائل",
      title_36: "عزاب",
      title_37: "وصف للعقار",
      title_38: "وصف  تفصيلي للعقار",
      title_39: "السعر",
      title_40: "صور العقار",
      title_41: "المنطقة",
      title_42: "المدينة",
      title_43: "الحي",
      title_44: "الشارع",
      title_45: "رقم العقار",
      title_46: "رقم الطابق",
      title_47: "عدد الطوابق",
      title_48: "رقم الشقة",
      title_49: "عمر العقار",
      title_50: "مساحة العقار",
      title_51: "عدد الغرف",
      title_52: "عدد الحمامات",
      title_53: "الموقع",
      title_54: "خط الطول",
      title_55: "خط العرض",
      title_56: "أضافة مميزات العقار",
      title_57: "تفاصيل الاعلان",
      title_58: "الإعلان يصنف كإعلان مميز",
      title_59: "أرسال",
      title_60: "حفظ المميزات",
      agencyPhoto: 'صورة الوكالة',
      
    },

    login: {
      title_1: "تسجيل الدخول",
      title_2: "رقم جوالك",
      title_3: "أدخل رقم جوالك",
      title_4: "كلمة المرور",
      title_5: "أدخل كلمة المرور",
      title_6: "هل نسيت كلمة المرور ؟",
      title_7: "ليس لديك حساب ؟",
      title_8: "إنشاء حساب جديد",
      title_9: "نفـاذ ",
    },

    terms: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'الشروط والاحكام',
      title_1: 'اتفاقية الشروط والأحكام',
      title_2: 'هذه الاتفاقية بتاريخ 09 /01/ 2026 م',
      title_3: 'مقدمة',
      introduction: 'يخضع دخولك واستخدامك لموقع أو تطبيق أحمد المحيسني العقارية لهذه الشروط والأحكام وأنظمة المملكة العربية السعودية كما يُعد وصولك ودخولك إليها موافقةً دون قيد أو شرط على هذه الشروط والأحكام وسياسة الخصوصية سواءً كنت مستخدمًا مسجلًا أم لم تكن وتقر وتضمن أهليتك القانونية للدخول في هذه الاتفاقية وفقًا لجميع الشروط والأحكام الواردة فيها وتسري هذه الاتفاقية اعتبارًا من تاريخ أول استخدام لك لموقع أو تطبيق أحمد المحيسني العقارية',
      introduction_1: "إن اتفاقية الشروط والأحكام التي تم نشرها على موقع أو تطبيق أحمد المحيسني العقارية وُضعت لحماية وحفظ حقوق كل من الموقع أو تطبيق أحمد المحيسني العقارية والمستخدمين الذين يستفيدون من خدمات الموقع أو التطبيق لشركة أحمد المحيسني العقارية بتسجيل أو من دون تسجيل.",
      definitions: " شركة أحمد المحيسني العقارية هي شركة مسجلة في المملكة العربية السعودية ومقرها الرئيس في مدينة الرياض بالمملكة العربية السعودية تدير وتشغل الخدمات سواء الموقع أو التطبيق الخاص بشركة أحمد المحيسني العقارية.",
      definitions_1: "تقدم شركة أحمد المحيسني العقارية سواء بالموقع أو التطبيق الخدمات التسويقية والعقارية والسياحية ومزودي الخدمات وتشمل على سبيل المثال لا الحصر تطبيق أحمد المحيسني العقارية السعودية على نظام iOS وتطبيق أحمد المحيسني العقارية السعودية على نظام أندرويد وموقع أحمد المحيسني العقارية السعودية https://aqaralmuhaysini.com",
      definitions_2: "الموقع: موقع أحمد المحيسني العقارية المتاح من خلال الرابط التالي https://aqaralmuhaysini.com وكافة المواقع والصفحات التي يمكن الدخول إليها من خلال الموقع أو التطبيق المذكور ويشمل المصطلح أيضًا التطبيقات الحاسوبية وتطبيقات الهاتف الذكي على منصات أندرويد أو iOS المتصلة بذلك وكافة الخدمات والمزايا التي توفرها شركة أحمد المحيسني العقارية وحيثما يدل النص على ذلك يُستخدم المصطلح للإشارة إلى المشغل.",
      definitions_3: "المستخدم: أي شخص طبيعي أو اعتباري يستخدم موقع أحمد المحيسني العقارية للاستفادة من الخدمات التي تُقدم من خلال موقع أو تطبيق سواءً بتسجيل أو بدون تسجيل ويُشار إليهم مجتمعين في هذه الاتفاقية بـ (المستخدمين).",
      definitions_4: "مزودو الخدمة: الذين يقدمون الخدمات عبر الموقع أو التطبيق حيث تقوم شركة أحمد المحيسني العقارية بربط مزودي الخدمات مع المستخدمين بالموقع أو التطبيق ويمكن من خلالها البحث عن المنتجات المطلوبة من قبل المستخدم وطلبها من مزودي الخدمة",
      articleOne: "تخضع هذه الأحكام والشروط إلى الأنظمة واللوائح النافذة في المملكة العربية السعودية وإذا تعارض أي من الأحكام الواردة في هذه السياسة مع الأنظمة والتشريعات النافذة في المملكة العربية السعودية فإنها لا تؤثر على باقي الأحكام وتُعتبر بقية الشروط والأحكام نافذة.",
      articleOne_1: "تسعى شركة أحمد المحيسني العقارية قدر الإمكان إلى توفير المعلومات بشكل صحيح ودقيق إلا أنه قد ترد بعض الأخطاء من حين لآخر ولا يتحمل موقع أو تطبيق أحمد المحيسني العقارية أي مسؤولية عن أي خطأ في المعلومات التي يتضمنها موقع أو تطبيق أحمد المحيسني العقارية ولا تمنح أية ضمانات صريحة كانت أو ضمنية تتعلق دون استثناء بعدم القابلية للانتهاك أو الصلاحية المتعلقة بأي أمر من الأمور ولا يتحمل موقع أو تطبيق أحمد المحيسني العقارية أي مسؤولية عن المحتويات المتوفرة في أي موقع آخر يتم الوصول إليه عبر هذه القنوات الإلكترونية أو الوصول منه إلى موقع أو تطبيق أحمد المحيسني العقارية.",
      articleOne_2: "يبذل موقع أو تطبيق أحمد المحيسني العقارية جهودًا لضمان جودة المعلومات المنشورة ولا تتحمل أي مسؤولية تجاه الغير في حال خرق الشروط والأحكام ويحق لها إيقاف الخدمة عن ضرر ناتج من المستخدم مع الاعتماد على المصادر الأساسية وموقع أو تطبيق أحمد المحيسني العقارية غير مسؤولة عن التصرفات غير المشروعة التي قد يقوم بها مزودو الخدمة أو المستخدمون.",
      articleOne_3: "عدم الإعلان أو عرض أي سلع أو خدمات أو إجراء أو إرسال دراسات استقصائية أو سلاسل رسائل أو تحميل أي ملف ينشر من قبل المستخدم مخالف لسياسة الخصوصية والشروط والأحكام لموقع أو تطبيق أحمد المحيسني العقارية وينبغي العلم أنه لا يسمح بالترويج لها بهذه الطرق قانونيًا.",
      articleTwo: "عند استخدامك موقع أو تطبيق أحمد المحيسني العقارية فإنك تقر وتلتزم بالتالي تقر وتضمن أهليتك القانونية للدخول في هذه الاتفاقية وفقًا لجميع الشروط والأحكام الواردة فيها واستخدام الموقع أو التطبيق بصفتك الشخصية أو بالنيابة عن شخص لك الحق في تمثيله على موقع أو تطبيق أحمد المحيسني العقارية على سبيل المثال لا الحصر عن طريق الوكالة أو التوظيف فقط وعدم استخدام موقع أو تطبيق أحمد المحيسني العقارية بصفة أي شخص لا يحق لك تمثيله ويدرك المستخدم كافة التبعات القانونية التي تترتب على التزويد بالمعلومات المدخلة والمواد الخاطئة أو غير الصحيحة أو غير الدقيقة أو غير المشروعة أو غير المكتملة أثناء إجرائه لأي استخدام وعدم مشاركة أي معلومات ليس لديك حق نشرها أو مشاركتها.",
      articleTwo_1: "يقر المستخدم بكامل مسؤوليته بأن موقع أو تطبيق أحمد المحيسني العقارية لا تتحمل أي مسؤولية تجاه المستخدم أو تجاه أي طرف ثالث عن أي محتوى منشور على موقع أو تطبيق أحمد المحيسني العقارية ويتحمل المستخدم أي تبعات أخرى بما في ذلك أي ضرر أو خسارة يتعرض لها موقع أو تطبيق أحمد المحيسني العقارية أو أي طرف ثالث جراء أي إخلال من هذا القبيل ويحق لموقع أو تطبيق أحمد المحيسني العقارية اتخاذ الإجراءات اللازمة والرجوع على المستخدم في حال تعرض لأي ضرر سواءً كان مباشرًا أو غير مباشر ودفع كافة الرسوم المترتبة على خدمات موقع أو تطبيق أحمد المحيسني العقارية عند استحقاقها وانطباق كافة الاشتراطات والالتزامات الحكومية عليك وحصولك على كافة التراخيص المطلوبة للاستفادة من خدمات موقع أو تطبيق أحمد المحيسني العقارية.",
      articleTwo_2: "عدم التعدي على أي مستخدم آخر أو مزود خدمة في مختلف المجالات داخل موقع أو تطبيق أحمد المحيسني العقارية أو محاولة الغش أو الكذب أو التدليس لإلحاق الضرر بأي مستخدم آخر وعدم استخدام أي وسيلة بما في ذلك على سبيل المثال لا الحصر محاولة إخفاء الهوية عبر برامج الـVPN أو البروكسي Proxy لانتهاك الشروط والأحكام أو لتجاوز الإجراءات الوقائية أو للوصول إلى محتوى غير مسموح أو لتجميع أو تحصيل معلومات وبيانات تخص الموقع أو التطبيق أو مستخدميه أو إعادة نشرها بدون إذن وعدم نشر أو توزيع أو تحميل أي مواد تشهيرية أو هجومية أو انتهاكية أو مضرة أو تهديدية أو مسيئة أو ملتوية أو عنصرية أو غير ملائمة أخلاقيًا أو غير ذلك من محتوى أو معلومات غير قانونية وعدم نشر أي محتوى أو مواد وهمية أو تخمينية أو تعليقات كاذبة أو غير دقيقة أو مضللة أو خادعة أو قذف أو تشهير وعدم التعرض للسياسات أو السيادات الدولية أو الشخصيات المعتبرة أو أي مناقشات لا تتعلق بالخدمات المقدمة",
      articleTwo_3: "وعدم انتهاك حقوق الطبع والنشر والعلامات التجارية وبراءات الاختراع والدعاية وقواعد البيانات أو غيرها من حقوق الملكية أو الفكرية وعدم انتحال صفة شركة أحمد المحيسني العقارية أو ممثل لها أو موظف فيها أو أي صفة توحي بأنك تابع لها دون إذن رسمي ودرء الضرر عن شركة أحمد المحيسني العقارية وتعويضها عن كافة الالتزامات والخسائر والدعاوى والنفقات بما في ذلك الرسوم القانونية والأضرار سواء المباشرة أو غير المباشرة الناتجة عن إساءة الاستخدام وتحمل كافة المسؤولية القانونية والجنائية الناتجة عن أي مخالفة من قبل المستخدم أو مزود الخدمة.",
      articleThree: 'المادة الثالثة: أحكام خدمة (الإعلانات)',
      articleThree_1: "عند قيامك بنشر أي إعلان عقاري على موقع أو تطبيق أحمد المحيسني العقارية فإنك تقر وتلتزم بتطبيق كافة الأنظمة والقوانين والتشريعات ذات العلاقة والحصول على كافة التراخيص والتصاريح النظامية المطلوبة سواءً للعقار المعروض أو لمزود الخدمة وتوفر الأهلية والأحقية القانونية للإعلان العقاري وتحمل تبعات أي مخالفة لذلك وتحري الدقة في جميع معلومات الإعلان المعروض وأنها صحيحة على سبيل المثال لا الحصر القسم والتصنيف والصور والسعر والخدمات والوصف والموقع وأي اشتراطات أو قيود أخرى والتعهد بإبقاء تلك المعلومات محدثة على الدوام وتحمل تبعات عدم تحديثها وعدم إمكانية تعديل نوع ومكان الإعلان بعد نشره والتفاعل والرد على تواصل المستخدمين وفيما يخص العمولات دفع عمولة الإعلان المفروضة عند إتمام التصرف العقاري في حالة عدم الإعفاء من الرسوم.",
      articleFour: "المادة الرابعة: أحكام خدمة (الطلبات )",
      articleFour_1: "عند قيامك بنشر أي طلب على موقع أو تطبيق أحمد المحيسني العقارية فإنك تقر وتلتزم بالجدية في الطلب ودقة البيانات المدخلة فيه والتفاعل مع المستخدمين الذين يريدون التواصل والعكس للمستخدم بعد إرسال الطلب وعدم نشر طلبات وهمية لأي سبب ودفع أي رسوم مفروضة على نشر الطلب.",
      articleFive: "المادة الخامسة: أحكام خدمة (عميل مميز)",
      articleFive_1: "عند اشتراكك في خدمة موقع أو تطبيق أحمد المحيسني العقارية فإنك تقر وتلتزم بأن يتم تجديد الاشتراك دوريًا حسب تاريخ بداية التفعيل ويدرك المستخدم أن مميزات الخدمة قابلة للزيادة أو التغيير متى رأت شركة أحمد المحيسني العقارية ذلك مناسبًا وإساءة استخدام الخدمة على سبيل المثال لا الحصر استهداف الملاك لغرض التسويق أو العملاء بشكل عام يعرضك لإيقاف الخدمة دون استرجاع مبلغ الاشتراك ودون إشعار مسبق وتعتمد نتائج البحث لمرشحات عقار بلس على مدخلات المعلنين بالدرجة الأولى ولا يقدم موقع أو تطبيق أحمد المحيسني العقارية أي ضمانات حول صحة المعلومات المدخلة",
      articleSix: "المادة السادسة: أحكام خدمة (البيع السريع)",
      articleSix_1: "في هذه المادة تُستخدم التعريفات التالية البيع السريع هي خدمة مقدمة على موقع أو تطبيق أحمد المحيسني العقارية تخدم المعلن الراغب في عرض خدماته لطالبي الخدمة ويقوم موقع أو تطبيق أحمد المحيسني العقارية باستقبال العروض من طالبي الشراء المحتملين والمعلن هو المالك لحق التصرف في الخدمة المقدمة أو من ينوب عنه أو الوسيط العقاري المرخص في حال كان عقارًا والمخول في ذلك للخدمة بشكل عام والراغب في عرضه في خدمة البيع السريع لاستقبال طلبات الشراء وطالب الشراء هو الشخص الراغب في تقديم عرض شراء معروض عبر خدمة البيع السريع ومدة الإعلان هي المدة التي يتاح فيها تقديم عرض شراء من طالبي الشراء وعرض الشراء هو عرض مالي مقدم من طالب الشراء لشراء السلع المعلن عنها من قبل المعلن ورسم الإعلان هو رسم يدفعه المعلن لموقع أو تطبيق أحمد المحيسني العقارية لنشر الإعلان عبر خدمة البيع السريع ورسم تقديم العرض هو رسم يدفعه طالب الشراء مقابل تقديم عرض الشراء للمعلن عبر موقع أو تطبيق أحمد المحيسني العقارية.",
      articleSix_2: "عند استخدامك لخدمة البيع السريع فإنك تفهم وتوافق على أن مسؤولية موقع أو تطبيق أحمد المحيسني العقارية تقتصر على التوسط في استلام عرض الشراء وإيصاله للمعلن وتوفير وسيلة تواصل بين الطرفين وعند عرض أي إعلان عبر خدمة البيع السريع بصفتك معلنًا فإنك تفهم وتوافق وتلتزم بتحملك كافة المسؤولية عن صحة البيانات المعروضة وتوفيرها لطالبي الشراء بكل دقة ونزاهة وتتحمل المسؤولية القانونية والمالية الكاملة في حال ثبت وجود أي تلاعب أو إخفاء لأي معلومة عن المعروض ودفعك لرسم الإعلان قبل نشر الإعلان ويكون رسم الإعلان مستردًا إذا لم يصل للمعلن أي عرض شراء خلال مدة الإعلان والالتزام بقبول أحد عروض الشراء المتجاوزة للسعر الأدنى في حالة عدم امتناع طالب الشراء الذي قدم العرض عن إتمام التصرف العقاري فيما يخص العقار.",
      articleSix_3: "وعند تقديم عرض شراء لأي من المعروض في خدمة البيع السريع بصفتك طالب شراء فإنك تفهم وتقر وتلتزم بأن السعر المقدم لا يشمل ضريبة التصرفات العقارية في حال كان المعروض عقارًا أو أي رسوم أو عمولات أو ضرائب أخرى ويُعد رسم تقديم العرض عربونًا مقدمًا في حال اتفق المعلن والمشتري على إتمام الخدمة ويكون رسم تقديم العرض مستردًا فقط في حالات رفض المعلن أو عدم قدرته على إتمام البيع أو بيع الخدمة لطرف آخر أو وجود عيوب أو اختلاف جوهري في بيانات العقار ويتم إرجاع المبلغ خلال 15 يوم عمل بعد التحقق وفي حال إرجاع المبلغ وثبوت أن طالب الشراء أتم عملية الشراء من نفس المعلن خلال ثلاثة أشهر فإن لموقع أو تطبيق أحمد المحيسني العقارية الحق في الرجوع على المشتري لاسترداد رسم تقديم العرض وأي رسوم أو عمولات أخرى وتحميله كافة التكاليف القانونية والإدارية.",
      articleSeven: "المادة السابعة: أحكام خدمة (الربط بين المستخدم ومزود الخدمة)",
      articleSeven_1: "يلتزم موقع أو تطبيق أحمد المحيسني العقارية باحترام خصوصية المستخدمين وحماية أي معلومات شخصية تُجمع خلال استخدام الموقع أو التطبيق وتجري عملية جمع المعلومات الشخصية واستخدامها وفقًا للشروط والأحكام المذكورة وقد تشمل الحصول على معلومات إضافية من أطراف ثالثة مرخصة مثل علم وسمة وبيان وثقة ومصدر وإمضاء والمصرفية المفتوحة لتعزيز جودة وفعالية الخدمات المقدمة وتُستخدم هذه المعلومات لتسهيل حصول المستخدمين على عروض التمويل المناسبة وتقديمها بشكل واضح وفعال ويحرص الموقع أو التطبيق على مشاركة هذه المعلومات فقط مع الجهات المرخصة والمعتمدة ويحق للمستخدم تعديل بعض معلوماته الشخصية عبر الملف الشخصي ويوافق المستخدم على إمكانية الوصول إلى هذه البيانات ومعالجتها والاحتفاظ بها وفقًا للشروط والأحكام كما يهدف الموقع أو التطبيق إلى ربط العملاء بمزودي الخدمات مع مراعاة التزاماتهم الائتمانية وملاءتهم المالية وتقديم الخيارات المتاحة لهم.",
      articleEight: "المادة الثامنة:  تبادل المعلومات",
      articleEight_1: "يُعد استخدام المستخدمين لهذا الموقع أو التطبيق موافقة ضمنية على الشروط والأحكام الموضحة والتي تشكل عقدًا ملزمًا بين الطرفين ولا يقوم موقع أو تطبيق أحمد المحيسني العقارية ببيع البيانات الشخصية للمستخدمين وإنما يتم مشاركتها مع الجهات المرخصة والأطراف ذات العلاقة كجزء من تقديم الخدمات ولا يتطلب هذا التبادل الحصول على موافقة إضافية بعد بدء الاستخدام.",
      articleNine: "المادة التاسعة: عدم تقديم أي ضمانات",
      articleNine_1: "يقر ويوافق المستخدم بأن شركة أحمد المحيسني العقارية وأي من شركاتها التابعة أو المالكة لا تقدم أي ضمان من أي نوع كان فيما يتعلق بالمعلومات الشخصية أو جمعها أو معالجتها أو تخزينها أو حمايتها أو فعالية الإجراءات الأمنية ويوافق المستخدم على عدم تحمل الشركة أي مسؤولية عن أي مطالبات أو خسائر أو أضرار ناتجة عن الوصول أو الإفصاح أو الاستخدام أو التعديل أو إدخال فيروسات أو برمجيات ضارة كما يقر المستخدم بأن الشركة تخلي مسؤوليتها عن أي ضرر ينتج من عدم حصوله على الخدمة أو نتيجة استخدام الموقع أو التطبيق وتبذل الشركة الجهود اللازمة للمحافظة على سرية البيانات وعدم الإفصاح عنها إلا وفق الأنظمة المعمول بها.",
      articleTen: "المادة العاشرة: أحكام المدفوعات",
      articleTen_1: "عند قيامك بالدفع مقابل أي خدمة عبر موقع أو تطبيق أحمد المحيسني العقارية فإنك تقر وتلتزم بأنه يحق للموقع أو التطبيق رفض أي طلب استرجاع لأي مبلغ بعد الدفع ويستثنى من ذلك مبالغ الحجوزات التي تحكمها سياسة الإلغاء ويحق لك طلب نقل باقات الإعلانات العقارية لمستخدم آخر خلال خمسة أيام من تاريخ الدفع ويستغرق إرجاع المبالغ بعد الموافقة أربعة عشر يوم عمل وتتحمل أي رسوم تفرضها بوابات الدفع أو الحوالات عند طلب الاسترجاع.",
      articleEleven: "المادة الحادية عشرة: الإجراءات الوقائية",
      articleEleven_1: "سعيًا من شركة أحمد المحيسني العقارية لرفع مستوى وجودة الخدمة المقدمة لمستخدمي موقع أو تطبيق أحمد المحيسني العقارية وتبعًا لاستخدامك هذه الشروط والأحكام فإنك توافق وتعطي الشركة الحق في تطبيق أي من الإجراءات التالية دون سابق إنذار إذا تقرر لديها أنك خرقت اتفاقية الشروط والأحكام إيقاف عضويتك وحظرك بشكل مؤقت أو دائم من استخدام كل أو أي من خدمات الموقع أو التطبيق مع الاحتفاظ بالحق في عدم تعويضك عن أي خدمات مدفوعة مسبقًا وحذف كافة أو أي من المواد أو المحتوى الذي قام المستخدم بنشره والتبليغ عن الأنشطة الخاصة بك إلى السلطات المختصة واتخاذ أي إجراءات قانونية ضدك",

      articleTwelve: "المادة الثانية عشرة: حدود المسؤولية",
      articleTwelve_1: "عند استخدامك موقع أو تطبيق أحمد المحيسني العقارية فإنك تفهم وتوافق على أنه لا يقدم أي ضمانات ولا يتحمل أي مسؤولية في حالة عدم التزام المستخدم باتفاقية الشروط والأحكام ولا يتحمل المسؤولية عن أي مخاطرة أو أضرار أو تبعات أو خسائر تقع عليه أو على أي طرف آخر ولا يتحمل في أي حال من الأحوال المسؤولية عن أية أضرار بما في ذلك فقدان البيانات أو الأرباح أو انقطاع الأعمال الناتجة عن استخدام أو عدم القدرة على استخدام المحتوى أو الخدمات ولا يتحمل أي مسؤولية عن خسارة أو ضرر ناتج عن أعطال البرامج أو شبكة الإنترنت أو فقدان كلمة المرور أو الحساب أو أي خسارة مباشرة أو تبعية أو خاصة أو فقد البيانات أو تلفها أو فسادها أو عن أي فيروس أو هجوم تقني يصيب أجهزتك نتيجة استخدام الموقع أو التطبيق أو تحميل محتوى منها أو من مواقع مرتبطة بها",

      articleThirteen: "المادة الثالثة عشرة: سياسة حقوق الملكية الفكرية",
      articleThirteen_1: "عند مشاركة أي محتوى على موقع أو تطبيق أحمد المحيسني العقارية فإنك تفهم وتوافق على منح الموقع أو التطبيق حقًا غير محصور زمانًا ومكانًا وغير قابل للنقض وقابل للتوزيع والنقل للغير لنسخ وتعديل وتحريف ونشر ذلك المحتوى دون أي قيود وتتحمل تبعات أي محتوى مشارك ويكون للموقع أو التطبيق الحق في الإفصاح عن هويتك لأي طرف ثالث يدعي أن المحتوى المنشور يشكل انتهاكًا لحقوق الملكية الفكرية أو الخصوصية وعدم احتواء المحتوى على مواد تشهيرية أو هجومية أو انتهاكية أو مضرة أو تهديدية أو مسيئة أو عنصرية أو غير قانونية وإذا تضمن المحتوى أي معلومات شخصية فإن سياسة الخصوصية تحكم استخدامها وإذا دفعت لإنتاج المحتوى أو ساعدت في إنتاجه فقد تملك الشركة ذلك المحتوى.",

      articleFourteen: "المادة الرابعة عشرة: سياسة خصوصية البيانات",
      articleFourteen_1: "باستخدامك موقع أو تطبيق أحمد المحيسني العقارية فإنك توافق على قيام الموقع أو التطبيق بجمع معلوماتك الشخصية وبيانات تفاعلك لتطوير وتحسين الخدمات ويقر المستخدم بعلمه بأن للموقع أو التطبيق الحق في كشف أي معلومات للجهات المختصة متى كان ذلك لازمًا للالتزام بأي نظام أو طلب حكومي أو قضائي.",

      articleFifteen: "المادة الخامسة عشرة: تعديل الاتفاقية",
      articleFifteen_1: "عند استخدامك موقع أو تطبيق أحمد المحيسني العقارية فإنه يحق للموقع أو التطبيق إجراء تغييرات على الشروط من حين إلى آخر دون إشعار مسبق ويصبح أي تعديل نافذًا فور اعتماده ما لم يُبيّن خلاف ذلك ويخضع تفسير وتنفيذ هذه الشروط والأحكام للأنظمة المعمول بها في المملكة العربية السعودية وفي حال نشوء أي نزاع يتم السعي لحله وديًا فإن تعذر ينعقد الاختصاص المكاني للمحاكم المختصة بمدينة الرياض.",

      title_5: '(منصة احمد المحيسني العقارية )',
      title_6: 'التي تشغلها',
      title_7: 'شركة احمد المحيسني العقارية',
      title_8: 'فإنك تقر وتوافق، دون أي تعديل أو قيود أو تبديل، على اتفاقية الشروط والأحكام هذه وعلى أية سياسات أخرى تحكم الاستفادة من خدمات',
      title_9: '، وتقر وتضمن أهليتك القانونية للدخول في هذه الاتفاقية وفقاً لجميع الشروط والأحكام الواردة فيها.',
      title_10: 'يجب عليك قراءة الشروط والأحكام في كل مرة تقوم باستخدام',
      title_11: 'لضمان أنك على علم بكل الشروط والأحكام السارية حاليًا. وفقًا لذلك، فإن استمرارك باستخدامك لأي من',
      title_12: 'يعتبر موافقة منك على أي تغيير في الشروط والأحكام.',
      title_13: 'إن اتفاقية الشروط والأحكام التي تم نشرها على',
      title_14: 'وضعت لحماية وحفظ حقوق كل من ',
      title_15: '(شركة تطبيق احمد المحيسني العقارية)',
      title_16: 'و المستخدمين الذين يستفيدون من خدمات',
      title_17: 'بتسجيل أو من دون تسجيل.',
      title_18: 'التعريفات',
      title_19: ': هي شركة مسجلة في المملكة العربية السعودية ومقرها الرئيس في مدينة الرياض، المملكة العربية السعودية، وتدير وتشغل خدمات.',
      title_20: ': المواقع و التطبيقات التي تقدم شركة تطبيق احمد المحيسني العقارية الخدمات التسويقية العقارية والسياحية من خلالها،وتشمل على سبيل المثال لا الحصر :',
      title_21: 'تطبيق',
      title_22: 'احمد المحيسني العقارية',
      title_23: 'السعودية على نظام',
      title_24: 'السعودية على نظام أندرويد',
      title_25: 'موقع',
      title_26: 'السعودية',
      title_27: 'المستخدم: هو الشخص الحقيقي أو الاعتباري الذي ليصل أو يستخدم إلى',
      title_28: ' للاستفادة من الخدمات التي تقدم من خلال المنصة سواء بتسجيل أو بدون تسجيل. ويشار إليهم مجتمعين في هذه الاتفاقية بـ (المستخدمين).',
      title_29: 'المادة الأولى: الأحكام العامة',
      title_30: 'تخضع بنود هذه الاتفاقية لكافة الأنظمة والتشريعات والتعليمات سارية المفعول بالمملكة العربية السعودية.',
      title_31: 'ذا أصبح أي حكم من أحكام هذه الاتفاقية غير قانوني أو لاغي أو غير ساري المفعول بموجب أية أنظمة أو قوانين أو أحكام قضائية، فإن باقي الأحكام والشروط الأخرى في هذه الاتفاقية تبقى فاعلة وسارية المفعول وقانونية ومعمول بها في هذه الاتفاقية وقابلة للتطبيق بموجب القوانين.',
      title_32: 'تسعى',
      title_33: 'قدر الإمكان إلى توفير المعلومات على',
      title_34: 'بدقة متناهية، إلا أنه قد ترد بعض الأخطاء من حين لآخر، ولا تتحمل',
      title_35: 'أي مسؤولية عن أي خطأ في المعلومات التي تتضمنها',
      title_36: 'المادة الثانية: الاستخدام المقبول',
      title_37: 'عند استخدامك',
      title_38: 'فإنك تقر وتلتزم بالتالي:',
      title_39: 'تقر وتضمن أهليتك القانونية للدخول في هذه الاتفاقية وفقاً لجميع الشروط والأحكام الواردة فيها.',
      title_40: 'استخدام الموقع بصفتك الشخصية أو بالنيابة عن شخص لك الحق في تمثيله على',
      title_41: '(على سبيل المثال لا الحصر: عن طريق الوكالة أو التوظيف) فقط، وعدم استخدام',
      title_42: 'بصفة أي شخص لا يحق لك تمثيله.',
      title_43: 'ضمان صحة كافة المعلومات المدخلة في ',
      title_44: 'سواء كانت معلومات المستخدم أو مدخلة كمواد أو محتوى للمشاركة أو الإعلان عبر',
      title_45: 'عدم مشاركة أي معلومات ليس لديك حق نشرها أو مشاركتها.',
      title_46: 'عدم عن نسخ أي محتوى من',
      title_47: 'وإعادة نشره في مواقع أخرى بدون موافقة مالك المحتوى.',
      title_48: 'تحمل مسؤولية التحقق من تفاصيل أي محتوى منشور على',
      title_49: 'وتأكيده والاطمئنان إلى صحتها وتتحمل مسؤولية الاستعانة بأي مختص فني أو الحصول على المشورة القانونية قبل الالتزام بأي عملية، وتتحمل مسؤولية ضمان تصرفك بحسن نية تجاه أي أطراف أخرى.',
      title_50: 'دفع كافة الرسوم المترتبة على خدمات',
      title_51: 'عند استحقاقها.',
      title_52: 'انطباق كافة الاشتراطات والالتزامات الحكومية عليك وحصولك على كافة التراخيص المطلوبة للاستفادة من خدمات',
      title_53: 'عدم التعدي على أي مستخدم آخر داخل',
      title_54: 'أو محاولة الغش أو الكذب أو التدليس لإلحاق الضرر بأي مستخدم آخر.',
      title_55: 'عدم استخدام أي وسيلة (بما في ذلك -على سبيل المثال لا الحصر- محاولة إخفاء الهوية عبر برامج الـVPN أو البروكسي Proxy) لانتهاك الشروط والأحكام في',
      title_56: 'أو لتجاوز الإجراءات الوقائية التي تطبقها',
      title_57: 'عند مخالفة الشروط والأحكام أو للوصول لمحتوى',
      title_58: 'بشكل غير مسموح أو لتجميع وتحصيل معلومات وبيانات تخص',
      title_59: 'أو مستخدميها والاستفادة منها بأي شكل من الأشكال أو إعادة نشرها بدون إذن.',
      title_60: 'عدم نشر أو توزيع أو تحميل أي مواد تشهيرية أو هجومية أو انتهاكيه أو مضرة أو تهديدية أو مسيئة أو ملتوية أو عنصرية أو غير ملائمة أخلاقياً أو غير ذلك من محتوى أو معلومات غير قانونية.',
      title_61: 'عدم نشر أي محتوى أو مواد وهمية أو تخمينية أو تعليقات كاذبة أو غير دقيقة أو مضللة أو خادعة أو قذف أو تشهير.',
      title_62: 'عدم التعرض للسياسات أو السيادات الدولية أو الشخصيات المعتبرة أو أي مناقشات لا تتعلق بالخدمات المقدمة على',
      title_63: 'عدم انتهاك حقوق الطبع والنشر والعلامات التجارية، وبراءات الاختراع والدعاية وقواعد البيانات أو غيرها من حقوق الملكية أو الفكرية التي تملكها ',
      title_64: 'أو مرخصة لـ',
      title_65: 'عدم انتحال صفة (شركة تطبيق احمد المحيسني العقارية أو ممثل لها أو موظف فيهًا أو أي صفة توحي بأنك تابع لـ',
      title_66: 'ما لم يكن لديك إذن رسمي من',
      title_67: 'درء الضرر عن',
      title_68: 'وتعويضها عن أي وكافة الالتزامات والخسائر والدعاوى والنفقات (بما في ذلك الرسوم القانونية) والأضرار (سواء المباشرة أو غير المباشرة) التي تنشأ عن المطالبات الناتجة عن إساءة استخدامك لـ',
      title_69: '، بما في ذلك ودون حصر أي مطالبات تتضمن مزاعم تثبتُ صِحتُها وتُشكل انتهاكاً من جانبك لهذه الاتفاقية.',
      title_70: 'تحمل كافة المسؤولية القانونية والجنائية الناتجة عن أي مخالفة من قبل ',
      title_71: '(المستخدم)',
      title_72: 'لاتفاقية الشروط والأحكام.',
      title_74: 'عند قيامك بنشر أي إعلان عقاري على',
      title_75: 'فإنك تقر وتلتزم بالتالي:',
      title_76: 'تطبيق كافة الأنظمة والقوانين والتشريعات ذات العلاقة والحصول على كافة التراخيص والتصاريح النظامية المطلوبة للعقار المعروض وتوفر الأهلية والأحقية القانونية للإعلان العقاري وتحمل تبعات أي مخالفة لذلك.',
      title_77: 'تحري الدقة في جميع معلومات الإعلان المعروض وأنها صحيحة (على سبيل المثال لا الحصر: القسم والتصنيف والصور والسعر والخدمات والوصف والموقع وأي اشتراطات أو قيود على العقار)، والتعهد بإبقاء تلك المعلومات محدثة على الدوام في',
      title_78: 'وتحمل تبعات عدم تحديثها.',
      title_79: 'عدم إمكانية تعديل نوع ومكان الإعلان بعد نشره.',
      title_80: 'التفاعل والرد على تواصل المستخدمين بخصوص الإعلان.',
      title_81: 'دفع عمولة الإعلان المفروضة عند إتمام التصرف العقاري (في حالة عدم الإعفاء من الرسوم).',
      title_82: 'المادة الرابعة: أحكام خدمة (الطلبات العقارية)',
      title_83: 'عند قيامك بنشر أي طلب عقاري على',
      title_84: 'الجدية في الطلب العقاري ودقة البيانات المدخلة فيه.',
      title_85: 'التفاعل مع المستخدمين الذين يريدون التواصل.',
      title_86: 'عدم نشر طلبات وهمية لأي سبب.',
      title_87: 'دفع أي رسوم مفروضة على نشر الطلب العقاري.',
      title_88: 'المادة الخامسة: أحكام خدمة (احمد المحيسني العقارية – عميل مميز)',
      title_89: 'عند اشتراكك في خدمة',
      title_90: '(احمد المحيسني العقارية)',
      title_91: 'يتم تجديد الاشتراك دورياً حسب تاريخ بداية التفعيل.',
      title_92: 'مميزات خدمة',
      title_93: " قابلة للزيادة أو التغيير متى رأت",
      title_94: 'ذلك مناسباً.',
      title_95: 'إساءة استخدام الخدمة (على سبيل المثال لا الحصر: استهداف الملاك لغرض التسويق) يعرضك لإيقاف الخدمة عنك دون استرجاع مبلغ الاشتراك ودون إشعار مسبق.',
      title_96: 'نتائج البحث لمرشحات عقار بلس تعتمد على مدخلات المعلنين بالدرجة الأولى ولا تقدم',
      title_97: 'أي ضمانات حول صحة المعلومات المدخلة.',
      title_98: 'المادة السادسة: أحكام خدمة (البيع السريع)',
      title_99: 'في هذه المادة، تستخدم التعريفات التالية:',
      title_100: 'البيع السريع',
      title_101: ': هي خدمة مقدمة على',
      title_102: 'تخدم المعلن الراغب في عرض عقاره لطالبي الشراء، وتقوم',
      title_103: 'باستقبال عروض الشراء من طالبي الشراء المحتملين.',
      title_104: 'المعلن',
      title_105: ' : هو المالك لحق التصرف في العقار (أو من ينوب عنه أو الوسيط العقاري المرخص والمخول في الوساطة لهذا العقار) والراغب في عرضه في خدمة',
      title_106: 'لاستقبال طلبات الشراء.',
      title_107: 'طالب الشراء',
      title_108: ': هو الشخص الراغب في تقديم عرض شراء لعقار معروض عبر خدمة ',
      title_109: 'مدة الإعلان',
      title_110: ': المدة التي يتاح فيها تقديم',
      title_111: 'عرض شراء',
      title_112: 'من',
      title_113: ': هو عرض مالي مقدم من',
      title_114: 'لشراء العقار المعلن عنه من قبلا',
      title_115: 'رسوم الاعلان',
      title_116: ': هو رسم يدفعه ',
      title_117: 'لـ',
      title_118: 'لنشر الإعلان عبر خدمة',
      title_119: 'في',
      title_120: 'رسوم تقديم العرض',
      title_121: 'مقابل تقديم ',
      title_122: 'للمعلن',
      title_123: 'عبر',
      title_124: 'عند استخدامك لخدمة',
      title_125: 'فإنك تفهم وتوافق على أن:',
      title_126: 'مسؤولية',
      title_127: 'تقتصر على التوسط في استلام',
      title_128: 'وإيصاله',
      title_129: 'وتوفير وسيلة تواصل بين الطرفين.',
      title_130: 'عند عرض',
      title_131: 'اعلان',
      title_132: 'عبر خدمة',
      title_133: 'بصفتك',
      title_134: 'معلن،',
      title_135: 'فإنك تفهم وتوافق وتلتزم بالتالي:',
      title_136: 'تحملك كافة المسؤولية عن صحة بيانات العقار المعروضة وتوفيرها',
      title_137: 'لطالبي الشراء',
      title_138: 'بكل دقة ونزاهة، وتحملك المسؤولية القانونية والمالية الكاملة في حال ثبت وجود أي تلاعب أو إخفاء لأي معلومة عن العقار المعروض.',
      title_139: 'دفعك',
      title_140: 'لرسم الإعلان',
      title_141: 'قبل نشر الإعلان.',
      title_142: 'مستردة إذا لم يصل',
      title_143: 'أي',
      title_144: 'خلال',
      title_145: 'من خلال',
      title_146: 'التزامك بقبول أحد',
      title_147: 'عروض الشراء',
      title_148: ' المتجاوزة للسعر الأدنى في حالة عدم امتناع',
      title_149: 'الذي قدم العرض عن إتمام التصرف العقاري.',
      title_150: 'عند تقديم',
      title_151: 'لأي عقار معروض في خدمة',
      title_152: 'طالب شراء',
      title_153: 'فإنك تفهم وتقر وتلتزم بالتالي:',
      title_154: 'السعر المقدم في',
      title_155: 'هو سعر العقار ولا يشمل ضريبة التصرفات العقارية أو أي رسوم أو عمولات أو ضرائب أخرى.',
      title_156: 'يعتبر رسم تقديم العرض',
      title_157: 'عربونًا مقدمًا في حال اتفق',
      title_158: 'و',
      title_159: 'المشتري',
      title_160: 'على إتمام التصرف العقاري.',
      title_161: 'رسم تقديم العرض',
      title_162: 'مسترد فقط في الحالات التالية:',
      title_163: 'رفض',
      title_164: 'أو عدم قدرته على إتمام البيع لطالب الشراء.',
      title_165: 'بيع العقار لطرف آخر غير ',
      title_166: 'ظهور خلل فادح في بيانات العقار أو إخفاء لبيانات جوهرية',
      title_167: 'يتم إرجاع مبلغ',
      title_168: 'رسم تقديم العرض',
      title_169: 'خلال ١٥ يوم عمل من تحقق سبب الإرجاع لدى ',
      title_170: 'إلى الحساب البنكي لطالب الشراء أو بطاقة المدفوعات المستخدمة في عملية الدفع',
      title_171: 'في حالة إرجاع مبلغ',
      title_172: ' وثبوت أن',
      title_173: 'أتم عملية شراء العقار من نفس',
      title_174: 'خلال (3) أشهر من عرضه في',
      title_175: '، فإن لـ',
      title_176: 'الحق في الرجوع على',
      title_177: 'المشتري',
      title_178: 'لاسترداد رسم تقديم العرض وأي رسوم أو عمولات أخرى مستحقة لـ(',
      title_179: 'وتحميله كافة التكاليف القانونية والإدارية للمطالبة بهذه المبالغ.',
      title_180: 'المادة السابعة: أحكام خدمة (الحجز اليومي)',
      title_181: 'في هذه المادة، تستخدم التعريفات التالية:',
      title_182: 'الحجز اليومي',
      title_183: 'تخدم المؤجّر الذي يرغب في عرض الوحدات المتاحة لديه للتأجير قصير المدى أو السياحي والمستأجر الباحث عن الوحدات المتاحة للتأجير قصير المدى أو السياحي.',
      title_184: 'المؤجّر',
      title_185: ': هو الشخص الحقيقي أو الاعتباري الذي يقدم خدمات الضيافة أو تأجير الوحدات قصيرة المدى.',
      title_186: 'المستأجر',
      title_187: ': هو الشخص الحقيقي أو الاعتباري الذي يستفيد من خدمات الضيافة أو تأجير الوحدات قصيرة المدى.',
      title_188: '',
      title_189: '',
      title_190: '',
      title_191: '',
      title_192: '',
      title_193: '',
      title_194: '',
      title_195: '',
      title_196: '',
      title_197: '',
      title_198: '',
      title_199: '',
      title_200: '',
    },

    formSuccess: {
      title_1: "تم رفع البيانات بنجاح",
      title_2: "ستتواصل معك إدارة الاعلانات خلال ٢٤ ساعة ",
      title_3: "لاستكمال إعلانك بكل نجاح من خلالنا",
      we_willContact: "سنتواصل معك لاستكمال الطلب",
      title_4: "العودة للرئيسية",
    },

    createfinance: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'طلب التمويل العقاري',
      title_1: "بيانات التمويل العقاري",
      title_2: "الاسم بالكامل",
      title_3: "رقم الجوال",
      title_4: "صافي دخلك الشهري ( الراتب )",
      title_5: "المبلغ",
      title_6: "اذكر الالتزامات القائمة عليك بالكامل",
      title_7: "تقديم طلب تمويل عقاري",
      title_8: "تم استلام طلب تمويلك العقاري.",
      // title_9: "التمويل العقاري الخاص بك",
      // title_10: "حجز العقار لتضمن بقاءة لك لحين ما نجهز طلب",
      // title_11: "سنعمل على طلبك و نتواصل معك قريبا, استمر في",
      finace_P: "سيقوم الفريق بمراجعته والتواصل معك قريبًا، ويمكنك متابعة حجز العقار إلى حين استكمال الإجراءات",
      title_12: "الرجوع الى الرئيسية",
    },

    rentalDetails: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'تفاصيل عن العقار',
      title_1: 'حالة العقار',
      title_2: 'تفاصيل الإيجار',
      title_4: 'الدفعات المتبقية',
      title_5: 'مدة الإيجار كاملة',
      title_6: 'موعد الدفعة القادمة',
      title_7: 'الدفعات المتأخرة',
      title_8: 'موعد انتهاء الإيجار',
      title_9: 'الموقع',
      title_10: 'طلب التمويل',
      title_11: 'طلب صيانه',
      propertyDetails: "تفاصيل العقار",
      paid: 'تم دفع',
      Rentpayments_due: 'دفعات الايجار المستحقة',
      PropertyManager: "مدير العقار",
      Ahmed_AlMuhaisni_Company: "شركة أحمد المحيسنى العقارية",
      backToHome: "العودة للرئيسية",
      installmentDue: "تم دفع القسط المستحق بنجاح",
      upcomingPayments: "الدفعات القادمة :",
      dueDate: "تاريخ الاستحقاق:",
      PayingRent: "دفع الايجار",
      totalUnits: "إجمالي الوحدات",
      vacancies: "الشاغر",
      landlord: "المؤجر",
      sold: "المباع",
    },

    photographyDetails: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'تصوير احترافي لعقار',
      breadcrumb_3: 'التحديثات',
      Cancel_Order_Button: 'الغاء الطلب',
      title_1: 'الغاء الطلب',
      title_2: 'اسباب الغاء الطلب',
      title_3: 'اختر سبب الغاء الطلب',
      payOrder: "دفع الطلب",
      cancel_photorequest: "الغاء طلب التصوير",
    },

    photography: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'إضـافـة إعــلان',
      breadcrumb_3: 'طلب تصوير احترافي',
      title_1 : "⁠لا تَعرِض عقارك، بل اروِ قصته!",
      title_2 : "تصوير احترافي يجعله الأكثر طلباً",
      title_3 : "ويُغلِق الصفقة بسرعة.",
      button_nextStep : "طلب تصوير احترافي",
      fullName: "⁠ الاسم بالكامل",
      name_placeholder: "ادخل ⁠الاسم بالكامل",
      phoneNumber: "رقم الهاتف",
      mobile_placeholder : "ادخل رقم الهاتف",
      region: "المنطقة",
      city: "المدينه",
      fullAddress: "العنوان بالتفصيل",
      location: "الموقع علي الخريطه",
      package: "اختيار الباقة المناسبة",
      button_Payment: "الدفع وارسال الطلب",
      requestReceived: "تم استلام طلبك",
      contactedSoon: "سيتم التواصل معك قريباً لتنسيق موعد التصوير مع مصور محترف .",
      title_6 : "",
      title_7 : "",
      title_8 : "",
      title_9 : "",
      title_10 : "",
      title_11 : "",
      title_12 : "",
      title_13 : "",
      title_14 : "",
      title_15 : "",
      title_16 : "",
      title_17 : "",
      title_18 : "",
      title_19 : "",
      title_20 : "",
    },

    lawyerRequested: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'تواصل مع محاميك',
      fullName: "الاسم بالكامل",
      enter_Fullname: "اكتب اسمك هنا",
      phoneNumber: "رقم الهاتف",
      enterPhoneNumber: "أدخل رقم جوالك",
      consultationDescription: "وصف الاستشارة",
      detailsInquiry: "اكتب تفاصيل استفسارك القانوني",
      Submitrequest: "ارسال الطلب بسرية تامة",
      successfullySubmitted: "تم تقديم طلب استشارة قانونية بنجاح ، سنتواصل معك قريبا",
      attachDocuments: "إرفاق المستندات (اختياري)",
    },

    lawyerDetails: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: 'تواصل مع محاميك',
      fullName: "الاسم بالكامل",
      mobile: "رقم الجوال ",
      description: "وصف الاستشارة",
      comments: "التعليقات والتحديثات",
    },

    advertismentReport: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: "الإبلاغ عن هذا الإعلان",
      reason: "السبب",
      writeReport: "اكتب نص البلاغ",
      btnConfrim: "أرسال",
      btnCancel: "ألغاء",
      succes: "استلمنا بلاغك وجاري التحقق منه",
    },

    propReservationDetails: {
      breadcrumb_1: 'الرئيسية',
      breadcrumb_2: "حجوزاتى",
      breadcrumb_3: "تفاصيل حجز العقار",
    },

    businessTransferDetails: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "تفاصيل التقبيل",
      Advertisementdetails: "تفاصيل الاعلان",
      ActivityDescription: "وصف النشاط",
      Reason: "سبب التقبيل",
      assetsList: "الأصول والموجودات",
      listofassets: "قائمة عن الأصول داخل مشروعك (معدات – أجهزة – أثاث – ديكور – رخصة تشغيل...)",
      FixedAsset: "حالة الاصول الثابته",
      financialObligations: "يوجد التزامات مالية أو ديون",
      ProjectStrengths: "نقاط قوة المشروع",
      projectWeaknesses: "نقاط ضعف المشروع",
      projectAge: "عمر المشروع",
      remainingTerm: "مدة عقد الايجار المتبقية",
      floorsCount: "عدد الطوابق",
      officesCount: "عدد المكاتب",
      hallsCount:  "عدد الصالات",
      parkingCount: "عدد مواقف السيارات",
      projectArea: "مساحة المشروع",
      square: "م2 ",
      View: "الواجهه",
      doorsCount: "عدد الابواب",
      roomsCount: "عدد الغرف",
      bathroomsCount: "عدد دورات المياة",
      applicant: "مقدم الطلب",
      reservePreview: "حجز معاينة",
      totalPrice: "السعر الاجمالى",
    },

    contactUs: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "اتصل بنا",
      name: "الاسم",
      communication: "رقم الجوال",
      description: "الموضوع",
      uploadingImages: "ارفاق صورة (اختياري)",
      send: "ارسال",
      receivedDetails: "شكراً لك استلمنا بياناتك وراح نتواصل معك في أقرب وقت",
      btn_submit: 'العودة للرئيسية'

    },

    register: {
      title_1: "إنشاء حساب جديد",
      title_2: "الاسم بالكامل",
      title_3: "رقم جوالك",
      title_4: "رقم الهوية",
      title_5: "كلمة السر",
      title_6: "تسجيل الحساب",
      title_7: "لديك حساب بالفعل ؟",
      title_8: "تسجيل دخول",
      title_9: "اضغط بعد الموافقة من نفاذ",
      title_10: "ادخل رمز الدخول المتغير",
      title_11: "تم ارسال رمز ال",
      title_12: "الي رقم جوال",
      title_13: "ادخل اسمك هنا",
      title_14: "ادخل رقم جوالك",
      title_15: "ادخل رقم الهوية",
      already_login: "انت مسجل لدينا بالفعل ،،، شكراً لك",
      installText: "يرجى تحميل التطبيق ثم الضغط على الرابط مرة اخرى ،،، شكراً لك",
    },

    formLogin: {
      title_1: "يجب تسجل الدخول",
      title_2: "يجب عليك تسجيل الدخول الى ",
      title_3: "حسابك / إنشاء حساب جديد",
      title_4: "تسجيل الدخول",
      title_5: "إنشاء حساب جديد",
      title_6: "نفـاذ",
    },

    footer:{
      title_1: 'تابعنا هنا',
      title_2: '⁠كافة حقوق النشر محفوظه لشركه أحمد المحيسني العقارية',
      title_3: 'من نحن',
      title_4: 'الرئيسية',
      title_6: 'الشروط والاحكام',
      privacyPolicy: "سياسية الخصوصية",
      contactUs: "اتصل بنا",
      complaints: "الشكاوي والبلاغات",
    },

    privacyPolicy: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "سياسية الخصوصية",
      Website: "تطبيق وموقع احمد المحيسني العقارية (Aqar Almuhaysini)",
      lastUpdate: "آخر تحديث: 15/1/2026",
      scopePolicy: "1.	نطاق هذه السياسة",
      scopePolicy_P: "توضح هذه السياسة كيفية جمع واستخدام وحماية البيانات الشخصية للمستخدمين عند استخدام تطبيق احمد المحيسني العقارية والموقع الإلكتروني aqaralmuhaysini.com، ويشمل ذلك المالكين، المستأجرين، المشترين، الوسطاء، مزودي الخدمات، والزوار.",
      dataCollect: "2.البيانات التي نقوم بجمعها",
      dataCollect_T: "قد نقوم بجمع الأنواع التالية من البيانات:",
      dataCollect_l1: "أ) بيانات الهوية: الاسم، رقم الهوية أو السجل التجاري، رقم الجوال، البريد الإلكتروني.",
      dataCollect_l2: "ب) بيانات العقار والمعاملات: بيانات الملكية أو التفويض، بيانات الوحدات العقارية، طلبات التأجير أو البيع، سجلات التفاوض والعروض.",
      dataCollect_l3: "ج) بيانات الاستخدام: سجل الطلبات، المحادثات داخل التطبيق، المكالمات المسجلة عند استخدامها عبر المنصة، الموقع الجغرافي التقريبي، عنوان IP.",
      dataCollect_l4: "د) بيانات الدفع: بيانات التحصيل، سجل الفواتير والعمولات، ويتم التعامل معها عبر مزودي دفع مرخصين ولا يتم تخزين بيانات البطاقات لدينا.",
      National_ID: "- رقم الهوية : مطلب اساسي يتم استخدامه للتحقق من بيانات الشخص عن طريق منصة نفاذ ( جهة حكومية ) وكذلك للتحقق من رقم الترخيص الإعلاني في حالة إضافة عقار. ",
      Mobile_Number: "- رقم الجوال : مطلب اساسي يتم استخدامه اثناء تسجيل مستخدم جديد حيث يتم ارسال كود تحقق على الجوال للتأكد من ان الشخص الذي يقوم بالتسجيل هو المالك لرقم الجوال بالفعل.",
      purposeData: "3. الغرض من جمع البيانات",
      purposeData_P: "يتم استخدام البيانات لتنفيذ عمليات الوساطة والتأجير والبيع، إدارة الأملاك والصيانة، توثيق العمليات والتعاقدات، التحصيل والدفع، الامتثال للأنظمة والجهات الرسمية، تحسين جودة الخدمة، وحل النزاعات وإثبات الحقوق.",
      LegalBasis: "4. الأساس النظامي للمعالجة",
      LegalBasis_P: "تتم معالجة البيانات بناءً على موافقة المستخدم عند التسجيل، وتنفيذ عقد أو طلب، والتزام نظامي وفق أنظمة المملكة، ومصلحة مشروعة لإدارة المنصة، وذلك وفق نظام حماية البيانات الشخصية السعودي.",
      dataSharing: "5. مشاركة البيانات",
      dataSharing_P: "قد تتم مشاركة البيانات مع الجهات الحكومية المختصة مثل هيئة العقار وإيجار والجهات القضائية، ومع مزودي الخدمات مثل الصيانة والدفع الإلكتروني والتوثيق، ومع الشركاء النظاميين داخل المنصة، ولا يتم بيع أو تأجير البيانات لأي طرف ثالث.",
      dataStorage: "6.تخزين وحماية البيانات",
      dataStorage_P: "نلتزم باتخاذ التدابير التقنية والتنظيمية لحماية البيانات من الاختراق أو التلاعب أو الفقد أو الاستخدام غير المصرح به، وتُخزن البيانات داخل أنظمة آمنة متوافقة مع متطلبات سدايا.",
      retentionPeriod: "7.مدة الاحتفاظ",
      retentionPeriod_P: "نحتفظ بالبيانات طالما أن الحساب نشط أو مطلوب نظاميًا أو لأغراض إثبات الحقوق أو فض النزاعات، ويتم حذفها أو إخفاؤها بعد انتهاء الغرض النظامي.",
      userRights: "8.حقوق المستخدم",
      userRights_P: "يحق للمستخدم طلب الاطلاع على بياناته، وطلب تصحيحها، وطلب حذفها ما لم يوجد التزام نظامي، وسحب الموافقة، وتقديم شكوى إلى سدايا عبر البريد الإلكتروني",
      recordingCalls: "9. تسجيل المكالمات والمحادثات",
      recordingCalls_P: "عند استخدام ميزات الاتصال أو الدردشة داخل التطبيق يقر المستخدم بموافقته على التسجيل وذلك لأغراض التوثيق والجودة وإثبات الحقوق، ولا يتم استخدامها لأي غرض آخر.",
      Amendments: "10.التعديلات",
      Amendments_P: "تحتفظ الشركة بحق تحديث هذه السياسة، ويُعد استمرار استخدام المنصة قبولًا بهذه التحديثات.",
      Responsible: "11.الجهة المسؤولة",
      Responsible_P: "شركة احمد المحيسني العقارية، المملكة العربية السعودية، الموقع الإلكتروني ",
    },

    privacyProvider: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "سياسة الخصوصية لتطبيق مندوب عقار المحيسني",
      lastUpdated: "آخر تحديث: (25/1/2026)",
      aqarAlmuhaysini_provider_App: "تحرص إدارة تطبيق مندوب عقار المحيسني على حماية خصوصية مستخدمي التطبيق من مزودي الخدمات، وتلتزم بالمحافظة على سرية وأمن البيانات الشخصية التي يتم جمعها أو معالجتها، وذلك وفقًا للأنظمة واللوائح المعمول بها في المملكة العربية السعودية.",
      byUsing_App: "باستخدامك للتطبيق، فإنك تقر بموافقتك على سياسة الخصوصية هذه وجميع ما ورد فيها.",
      Information_WeCollect: "أولًا: المعلومات التي نقوم بجمعها",
      personalInformation: "1. المعلومات الشخصية",
      followingInformation: "قد نقوم بجمع بعض أو كل المعلومات التالية:",
      fullName: "الاسم الكامل",
      mobileNumber: "رقم الجوال",
      emailAddress: "البريد الإلكتروني",
      nationalID: "رقم الهوية (عند الحاجة للتحقق)",
      profilePicture: "صورة الحساب الشخصي",
      bankAccount_Details: "بيانات الحساب البنكي (لأغراض صرف المستحقات)",
      serviceProvider_Information: "2. معلومات مزود الخدمة",
      typeService: "نوع الخدمة المقدمة (سباكة، كهرباء، صيانة، تصوير، وغيرها)",
      scopeWork: "نطاق العمل والمناطق المخدومة",
      availabilityTimes: "أوقات التوفر",
      offersPrices: "العروض والأسعار",
      historyCompleted : "سجل الطلبات المنفذة أو الجارية",
      locationInformation: "3. معلومات الموقع الجغرافي",
      providerLocation: "قد يطلب التطبيق الوصول إلى الموقع الجغرافي للمزود:",
      duringOrder: "أثناء استلام وتنفيذ الطلبات",
      propertyLocation: "لتوجيه المزود إلى موقع العقار",
      locationTracking: "ولا يتم تتبع الموقع بشكل دائم أو في الخلفية دون حاجة تشغيلية واضحة.",
      technicalInformation: "4. المعلومات التقنية",
      deviceType: "نوع الجهاز ونظام التشغيل",
      internetProtocol: "عنوان بروتوكول الإنترنت (IP)",
      usageData: "بيانات الاستخدام داخل التطبيق",
      performanceImprovement: "سجلات الأعطال وتحسين الأداء",
      howInformation: "ثانيًا: كيفية استخدام المعلومات",
      
      collectedInformation: "تُستخدم المعلومات التي يتم جمعها للأغراض التالية:",
      operating_TheApplication: "تشغيل التطبيق وإدارة حسابات مزودي الخدمات",
      connectingProviders: "ربط المزود بالطلبات المناسبة",
      organizingScheduling: "تنظيم وجدولة أعمال الصيانة", 
      Communicating: "التواصل بخصوص الطلبات أو التحديثات",
      verifyingIdentity: "التحقق من الهوية ومنع الاستخدام غير المشروع",
      processingPayments: "معالجة المدفوعات والمستحقات المالية",
      improvingService: "تحسين جودة الخدمة وتجربة المستخدم",
      Complying: "الامتثال للأنظمة والتعليمات الرسمية",
      Third_SharingInformation: "ثالثًا: مشاركة المعلومات",
      Almuhaysini_Provider_application: "لا يقوم تطبيق مندوب عقار المحيسني ببيع أو تأجير البيانات الشخصية لأي طرف ثالث.",
      data_maybe_Shared: "وقد تتم مشاركة بعض البيانات في الحالات التالية فقط:",
      clients: "مع العملاء بغرض تنفيذ الخدمة المطلوبة",
      electronic: "مع مزودي خدمات الدفع الإلكتروني",
      technicalPartners: "مع شركاء تقنيين (استضافة، دعم فني) لأغراض تشغيلية",
      governmentEntities: "مع الجهات الحكومية عند الطلب النظامي",
      Sharing: "وتكون المشاركة في أضيق نطاق يحقق الغرض المطلوب.",
      Fourth_InformationProtection: "رابعًا: حماية المعلومات",
      committedTaking: "نلتزم باتخاذ الإجراءات التقنية والتنظيمية المناسبة لحماية البيانات، بما في ذلك:",
      dataEncryption: "تشفير البيانات",
      systemsPrevent: "أنظمة حماية من الوصول غير المصرح به",
      restrictingAccess: "تقييد الوصول على الموظفين المخولين فقط",
      acknowledges: "ومع ذلك، يقر المستخدم بأن نقل البيانات عبر الإنترنت لا يمكن ضمانه بنسبة 100%.",
      Fifth_DataRetention: "خامسًا: الاحتفاظ بالبيانات",
      dataRetained: "يتم الاحتفاظ بالبيانات طالما كان حساب المزود نشطًا أو بحسب ما تقتضيه المتطلبات النظامية والتشغيلية، ويتم حذف أو إخفاء البيانات عند انتهاء الغرض منها، ما لم يوجد التزام نظامي بالاحتفاظ بها.",
      Sixth_ServiceProvider: "سادسًا: حقوق مزود الخدمة",
      serviceProvider: "يحق لمزود الخدمة:",
      personalData: "الاطلاع على بياناته الشخصية",
      update_Accountinformation: "تعديل أو تحديث بيانات الحساب",
      requestAccount: "طلب إيقاف الحساب",
      revoke_Certainprivileges: "سحب بعض الصلاحيات (مع العلم أن ذلك قد يؤثر على تقديم الخدمة",
      applicationAdministration: "ويمكن ممارسة هذه الحقوق من خلال إعدادات التطبيق أو التواصل مع إدارة التطبيق.",
      Seventh_CookiesSimilar_Technologies: "سابعًا: ملفات تعريف الارتباط والتقنيات المشابهة",
      analytical_Technologiesimprove: "قد يستخدم التطبيق تقنيات تحليلية لتحسين الأداء وتجربة الاستخدام دون المساس بالخصوصية الشخصية أو استخدام البيانات لأغراض إعلانية غير مصرح بها.",
      privacyPolicy: "ثامنًا: خصوصية القاصرين",
      application_Notintended: "التطبيق غير موجه لمن هم دون سن (18) عامًا، ولا يتم جمع بيانات قاصرين بشكل مقصود.",
      amendments_PrivacyPolicy: "تاسعًا: التعديلات على سياسة الخصوصية",
      amend_PrivacyPolicy: "يحتفظ تطبيق مندوب عقار المحيسني بالحق في تعديل سياسة الخصوصية عند الحاجة، وسيتم إشعار المستخدمين بأي تعديل جوهري عبر التطبيق أو وسائل التواصل المعتمدة.",
      application_Afteramendments: "استمرار استخدام التطبيق بعد التعديلات يُعد موافقة ضمنية عليها.",
      tenth_Contactingus: "عاشرًا: التواصل معنا",
      pleaseContactus: "للاستفسارات أو الطلبات المتعلقة بسياسة الخصوصية، يمكن التواصل عبر:",
      email: "البريد الإلكتروني",
      phoneNumber: "رقم التواصل: 920016962",
    },

    complaints: {
      breadcrumb_1: "الرئيسية",
      complaintsReports: "الشكاوى والبلاغات",
      Ahmed_AlMuhaisni_RealEstate: "تحرص شركة أحمد المحيسني العقارية على تمكين جميع المستخدمين من تقديم الشكاوى أو البلاغات المتعلقة بالخدمات أو المحتوى داخل المنصة، ويتم التعامل معها وفق الأنظمة المعمول بها في المملكة العربية السعودية.",
      submittingComplaint: "تقديم الشكوى",
      complaints_can_Submitted: "يمكن تقديم الشكوى عبر نموذج الموقع أو التطبيق، أو عبر البريد الإلكتروني، أو من خلال صفحة",
      contactUs: "“اتصل بنا”",
      processingResponse: "المعالجة والرد",
      complaints_are_reviewed: "تتم مراجعة الشكاوى خلال خمسة أيام عمل، ويتم التواصل مع مقدم الشكوى عند الحاجة.",
      Escalation: "التصعيد",
      complaint_the_General: "يحق للمستخدم تصعيد الشكوى إلى الهيئة العامة للعقار أو الجهة المختصة عند عدم الرضا عن النتيجة.",
      scope_Liability: "إساءة الاستخدام",
      companyLiability: "تقتصر مسؤولية الشركة على خدمات المنصة ولا تشمل النزاعات التعاقدية المباشرة بين الأطراف.",
      Abuse: "إساءة الاستخدام",
      companyReserves: "تحتفظ الشركة بحق إغلاق الشكاوى الكيدية أو غير الصحيحة.",
      complaint_Handling_Mechanism: "آلية معالجة الشكاوى",
      receivingComplaint: "استلام الشكوىيتم تسجيل الشكوى فور استلامها في النظام المخصص لذلك.",
      reviewing_theComplaint: "مراجعة الشكوى",
      specializedTeam: "يقوم الفريق المختص بمراجعة الشكوى والتحقق من تفاصيلها خلال مدة لا تتجاوز ثلاثة أيام عمل.",
      communicatingParties: "التواصل مع الأطراف",
      whenNecessary: "عند الحاجة، يتم التواصل مع المستخدم أو مزود الخدمة أو أي طرف ذي صلة لاستكمال المعلومات أو التحقق من الوقائع.",
      actionTaken: "اتخاذ الإجراء",
      appropriateAction: "يتم اتخاذ الإجراء المناسب وفق سياسات المنصة وشروطها، وقد يشمل:تنبيه المستخدم أو مزود الخدمة، إيقاف أو تعديل الإعلان، إيقاف الحساب مؤقتًا أو دائمًا، أو رفض الشكوى عند عدم ثبوتها.",
      notificationComplainant: "إشعار مقدم الشكوى",
      complainant_notified: "يتم إشعار مقدم الشكوى بنتيجة المعالجة خلال مدة لا تتجاوز عشرة أيام عمل من تاريخ الاستلام",
    },

    containerRet: {
      latePayments: "الدفعات المتأخرة",
      unitsProperty: " الوحدات داخل العقار",
      rentalName: "مستأجر العقار",
      propertyStatus: "حالة العقار",
      propertyDetails: "تفاصيل الوحدة",
    },
    nafath: {
      linkTitle: 'وثّق حسابك',
      cardTitle: 'توثيق الحساب',
      wellcome: 'مرحباً',
      verfiyText: 'يرجى توثيق حسابك عن طريق منصة نفاذ لتتمتع بمزايا شركة أحمد المحيسني العقارية',
      identity: 'رقم الهوية / الإقامة',
      submit: 'ارسل',
      identityRequired: 'يجب إدخال رقم الهوية',
      identityIncorrect: 'رقم الهوية غير صحيح',
      alreadVerified: 'حسابك موثق عن طريق نفاذ ،،، شكراً لك',
      nafathExplain: 'تم ارسال الدعوة لك ، يرجى الذهاب إلى تطبيق نفاذ وقبول الدعوة واختيار الرقم ادناه ثم الضغط على تم قبول الدعوة',
      checkNow: 'تم قبول الدعوة',
      notNow: 'في وقت لاحق',
      mustVerify: 'يجب عليك توثيق حسابك عن طريق تطبيق نفاذ حتى تتمكن من خدمات شركة أحمد المحيسني العقارية',
    },
    businessTransferUpdate: {
      ProjectData: "تعديل بيانات المشروع",
      successfullyModified: "تم تعديل طلب التقبيل بنجاح",
      saveChanges: "حفظ التغيرات",
    },
    mySubscription: {
      breadcrumb_1: "الرئيسية",
      breadcrumb_2: "اشتراكي",
      propertiesStand: "اجعل إدارة عقاراتك أكثر كفاءة ووضوحًا",
      customerService: "تأجير ومتابعة عقاراتك عبر نظام احترافي قائم على مؤشرات أداء واضحة:",
      fastestCustomer: "زمن استجابة خدمة العملاء: خلال وقت قصير",
      lowerCommission: "إدارة الأملاك: خصم 15% من النسبة السنوية",
      Faster_Stronger: "رفع الإعلانات مجانًا: نشر العقار خلال 24 ساعة",
      accountManager: "مدة إعادة التأجير: متوسط (يُحدد لاحقًا) يوم",
      forgiveness_Contract: "مدير علاقة مخصص: متاح من 9 صباحًا إلى 9 مساءً (6 أيام أسبوعيًا)",
      reducedMaintenance: " رسوم إبرام العقود: 0 ريال (إعفاء من رسوم المكتب)",
      freeProperty: " تقييم العقار: مجانًا خلال 48 ساعة",

      subscribeNow: "اشترك الان مقابل",
      subscribeNowt: "ريال شهريا",
      subscriptionSuccessful: "تم الأشتراك بنجاح!",
      congratulations: "مبروووك!، استمتع الان بجميع مميزات اشتراكك",
      returnMain: "عودة الى الرئيسية",
      terminationDate: "تاريخ توقف الاشتراك",
      SubscriptionFee: "قيمة الاشتراك",
      renewSubscription: "جدد إشتراكك",
      distinguishedOwner: "انت بالفعل مالك مميز",
    }
  },
};
export default Arabic;